import { jqxNotificationComponent } from 'jqwidgets-ng/jqxnotification';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { Component, OnInit, Inject, ViewChild, EventEmitter, Output, ElementRef, Input } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { NgxFileDropEntry, FileSystemFileEntry } from 'ngx-file-drop';
import { NgxSpinnerService } from 'ngx-spinner';
import { BackendService } from 'src/app/services/backend.service';
import { environment } from 'src/environments/environment';
import { jqxTextAreaComponent } from 'jqwidgets-ng/jqxtextarea';
import { NotesDialogData, MediaDialogData, AttachmentsDialogData, FileToUpload, JobCreateDto, JobCreateInputDto, EstimateDialogData } from 'src/app/models/apiRequestModels';
import * as JSZip from 'jszip';
import Swal from 'sweetalert2';
import { NgAudioRecorderService, OutputFormat } from 'ng-audio-recorder';
import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { cloneDeep, find, filter } from 'lodash';
import { MatRadioButton } from '@angular/material/radio';
import { NavigationStart, Router } from '@angular/router';
import { EMPTY, Observable, asyncScheduler, of, zip } from 'rxjs';
import { map, startWith, tap } from 'rxjs/operators';
import { jqxFormattedInputComponent } from 'jqwidgets-ng/jqxformattedinput';
import { ConfigurationServicePlaceholders } from 'aws-sdk/lib/config_service_placeholders';
import { error, log } from 'console';
import { ViewTNCComponent } from 'src/app/adminpages/tenant/tenant-creation/view-tnc/view-tnc.component';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import * as lamejs from '@breezystack/lamejs';
import { openDB } from 'idb';
import { FileAccessService } from 'src/app/services/fileaccess.service';
import { WakeLockService } from 'src/app/services/wake-lock.service';
import { Idle } from '@ng-idle/core';  // Assuming you're using ng-idle


interface PartETag {
    partNumber: number;
    eTag: string;
}

let zipFile;
let AudioFileFormats: [];
let DocumentFileFormats: [];
let fileMinSize = environment.AudioFileSize;
let ListzipFiles = [];
let ListOfZippedDocuments = [];
export interface dropdownmodel {
    name: string;
}
@Component({
    selector: 'app-upload-media',
    templateUrl: './upload-media.component.html',
    styleUrls: ['./upload-media.component.css']
})

export class UploadMediaComponent implements OnInit {
    @Output()

    @ViewChild('file', { static: false }) file
    @ViewChild('fileUploader', { static: false }) fileUploader: ElementRef;
    @ViewChild('msgNotification', { static: false }) msgNotification: jqxNotificationComponent;
    @ViewChild('notesComponent', { static: false }) notesComponent: jqxTextAreaComponent;
    @ViewChild('customerNotesComponent', { static: false }) customerNotesComponent: jqxTextAreaComponent;
    //oneTrans
    @ViewChild('oneTrans', { static: false }) oneTrans: MatRadioButton;
    //sepTrans
    @ViewChild('sepTrans', { static: false }) sepTrans: MatRadioButton;
    @ViewChild('masterJob', { static: false }) masterJob: MatRadioButton;
    @ViewChild('myFormattedInput', { static: false }) myFormattedInput: jqxFormattedInputComponent;

    notify: EventEmitter<string> = new EventEmitter<string>();
    ViewTnCdialogRef: MatDialogRef<ViewTNCComponent>;
    ListZipFailedFiles: any;
    ListOfOriginalFiles = [];
    ListOfZipFiles = [];
    IsMergeAudiosGlobal: boolean;
    ListOfMergeAudioFiles = [];
    MergeAudioFilescount = 0;
    MergeAudioFileNameList = [];
    CompleteAudioFilescount = 0;
    MergeAudioFormat: string;
    ListOfAttachmentFiles = [];
    ListOfAttachments1Global: FileToUpload[] = [];
    Audiofile = new FileToUpload();
    ListOfDuplicateFiles = [];
    DuplicateFileNames;
    ListOfFileFormats: any[] = [];
    Attachmentfile = new FileToUpload();
    progress: number;
    FileType = "";
    public originalFile: File;
    public ListOfNames: string;
    public isDuplicate: boolean;
    public ListOfAudioFiles: File[] = [];
    returnUrl: string;
    canUpload: boolean = false;
    MediaFileUploadUrl = "";
    removable = true;
    ref: any;
    isjob: any;
    showTransSelection: boolean = false;
    showTransSelectionMsg: boolean = false;
    showFileDragzone: boolean = false;
    showAudioFileList: boolean = false;
    showFileList: boolean = false;
    showNotes: boolean = false;
    showRecordzone: boolean = false;
    showAttachment: boolean = false;
    showMediaUpload: boolean = false;
    showRecording: boolean = false;
    showEstimateDetails: boolean = false;
    dialogTitle: string = "";
    altTitleNames: string = "";
    filelistTitle: string = "";
    dragButtonTitle: string = "";
    Notes = "";
    custNotes = "";
    notesDialogData = new NotesDialogData();
    mediaDialogData = new MediaDialogData();
    attachmentsDialogData = new AttachmentsDialogData();
    estimateDialogData = new EstimateDialogData();
    originalDataCopy;
    IsMergeAudios = false;
    isfutureorder: boolean;
    ListOfAttachments: FileToUpload[] = [];
    ListOfAudioFiles1: FileToUpload[] = [];
    ListofJobCreateDto: JobCreateDto[] = [];
    ListofJobCreateInputDto: JobCreateInputDto[] = [];
    exceedFileLimit: boolean;
    fileCount: number;
    maxNumberOfFiles: number;
    mode: string;
    resumeRecordShow: boolean = false;
    pauseButtonShow: boolean = false;
    interval;
    RecordingTimer: boolean = false;
    PauseRecordingTimer: boolean = false;
    stopButtonShow: boolean = false;
    startRecordShow: boolean = true;
    sec: any = '0' + 0;
    min: any = '0' + 0;
    hr: any = '0' + 0;
    GlobalOutput: any;
    image: string = "";
    transcriptionType: any;
    jobTypefilteredOptions: Observable<dropdownmodel[]>;
    jobTypeOptions: any[];
    EstimatejobtypeControl = new FormControl();
    selectedJobTypeExtId = "";
    selectedJobTypeDisplayName = "";
    jobCostMinuteRateEstimation = "";
    estimationForm: FormGroup;
    numberOfMins: number;
    totalEstimateAmount: number;
    receiptEmail: string;
    showEstimateAmount: boolean;
    showAcceptButton: boolean;
    isGenerateButtonEnable: boolean;
    termsAndConditionData?: {};
    languages: any[] = [];
    filteredLanguages: any[] = [];
    showCustomerNotes: boolean;
    ForeignLanguagevalues = [
        { value: 0, name: '--- Not Selected ---' },
        { value: 1, name: 'Foreign Language - Timestamp' },
        { value: 2, name: 'Foreign Language Transcription' },
        { value: 3, name: 'Interpretation' },
        { value: 4, name: 'Double Column - Transcription & Translation' },
        { value: 5, name: 'Stacked - Transcription & Translation' }
    ];
    ForeignLanguageControl = new FormControl(this.ForeignLanguagevalues[0], Validators.required);
    languageControl = new FormControl(this.languages[0]);
    selectedIndex: number = 0;
    organizationEstimateMessage: string;
    TenantEstimateMessage: string;
    DisplayEstimationMessage: string;
    FlCostMinuteRateEstimation: "";
    flLanguageService = 0;
    selectedLanguage: string;
    isForeignLanguage: boolean;
    selectedLanguageIndex: number = 0;
    estimateDateTime: string;
    departmentControl = new FormControl();
    departmentOptions: any[];
    deptfilteredOptions: Observable<dropdownmodel[]>;
    selectedDepartmentId = "";
    deptName: string;
    deptExtId: string;
    notesTitle: string = "";
    customerNotesEnable: any;
    IsAudioPlay: boolean;
    @Input() originalRecordingURL: string;
    @Input() convertedRecordingURL: string;
    recordingFileName: string = "";
    DisableStopRecording: boolean = false;
    showPlayDetails: boolean = false;
   //showRecordAudio : boolean = true;


    private processor!: ScriptProcessorNode;
    private stream!: MediaStream;
    private PrevioussessionId : string = "";
    private sessionId!: string;
    private audioContext!: AudioContext;
    private source!: MediaStreamAudioSourceNode;
    private mp3Encoder!: lamejs.Mp3Encoder;
    sampleBuffer: number[] = [];
    private dbPromise = openDB('Recordings', 1, {
        upgrade(db) {
            db.createObjectStore('chunks', { keyPath: 'id', autoIncrement: true });
        },
    });
    private dbPromise2 = openDB('uploadedParts', 1, {
        upgrade(db) {
            db.createObjectStore('uploadedParts', { keyPath: 'id'});
        },
    });
    
    uploadSession = { uploadId: '', fileKey: '' };
    currentSizeMB = 0;
    maxChunkSizeMB = 5;
    partNumber = 1;
    chunkIndex = 0;
    private isUploading = false;
    private PartETags: PartETag[] = [];
    isFinalChunk: boolean = false;
    private isRecording = false;
    private isStopping = false;
    private memoryBuffer: any[] = [];
    private readonly CHUNK_SIZE = 5 * 1024 * 1024; // 5 MB
    mediaRecorder: MediaRecorder;
    constructor(private formBuilder: FormBuilder,
        private backendService: BackendService,
        public dialogRef: MatDialogRef<UploadMediaComponent>,
        private spinner: NgxSpinnerService,
        private audioRecorderService: NgAudioRecorderService,
        private datePipe: DatePipe,
        private http: HttpClient,
        private router: Router,
        public dialog: MatDialog,
        private fileaccess: FileAccessService,
        private idle: Idle,
        private wakeLockService: WakeLockService,
        @Inject(MAT_DIALOG_DATA) public jobdata: any) { }
    async ngOnInit() {
        this.ref = this.jobdata.ref;
        this.isjob = this.jobdata.isjob;
        this.customerNotesEnable = this.jobdata.customerNotesEnable;
        this.router.events.subscribe(event => {
            if (event instanceof NavigationStart) {
                this.dialogClose("Cancel");
            }
        });
        if (this.ref === "estimate") {
            this.getTermsAndConditions();
            this.loadDeparmentValues();
            this.notify.emit("send data");
        }
        this.showCustomerNotes = this.isjob ? this.customerNotesEnable : false;
        this.showTransSelection = (this.jobdata.ref === "media" || this.jobdata.ref === "record") ? true : false;
        this.showTransSelectionMsg = (this.jobdata.ref === "media") ? true : false;
        this.showFileDragzone = (this.jobdata.ref === "media" || this.jobdata.ref === "attachDocs") ? true : false;
        this.showAudioFileList = (this.jobdata.ref === "media" || this.jobdata.ref === "record") ? true : false;
        this.showFileList = (this.jobdata.ref === "media" || this.jobdata.ref === "attachDocs" || this.jobdata.ref === "record") ? true : false;
        this.showRecordzone = (this.jobdata.ref === "record") ? true : false;

        this.showMediaUpload = (this.jobdata.ref === "media") ? true : false;
        this.showRecording = (this.jobdata.ref === "record") ? true : false;
        this.showAttachment = (this.jobdata.ref === "attachDocs") ? true : false;
        this.showNotes = (this.jobdata.ref === "addNotes") ? true : false;
        this.showEstimateDetails = (this.jobdata.ref === "estimate") ? true : false;
        if (this.showMediaUpload) {
            this.dialogTitle = "Select Audio/Video Files to Upload";
            this.filelistTitle = "List of selected and/or recorded Audio/Video files";
            this.dragButtonTitle = "Browse Audio/Video";
            this.image = "../../../assets/img/icon/upload-btn.png";
            this.altTitleNames = "Select Audio/Video Files";
        }
        if (this.showRecording) {
            this.dialogTitle = "Record Audio Files";
            this.filelistTitle = "List of selected and/or recorded Audio/Video files";
            this.image = "../../../assets/img/icon/record-btn.png";
            this.altTitleNames = "Record Audio";
        }
        if (this.showAttachment) {
            this.dialogTitle = "Attach Supporting Documents";
            this.filelistTitle = "List of attached supporting documents";
            this.dragButtonTitle = "Browse Documents";
            this.image = "../../../assets/img/icon/attachment-btn.png";
            this.altTitleNames = "Attach Supporting Documents";
        }
        if (this.showNotes) {
            this.dialogTitle = "Add Notes";
            this.image = "../../../assets/img/icon/add-notes-btn.png";
            this.altTitleNames = "Add Notes";
            this.notesTitle = this.isjob ? "Typist Notes" : "Notes";

        }
        if (this.showEstimateDetails) {
            this.dialogTitle = "Calculate Estimate";
            this.image = "../../../assets/img/icon/cost_estimation.png";
            this.altTitleNames = "Calculate Estimate";
        }

        this.http.get('assets/files/FileFormats.txt', { responseType: 'json' })
            .subscribe(data => {
                this.ListOfFileFormats[0] = data;
                var FormatsList = this.ListOfFileFormats[0];
                AudioFileFormats = FormatsList[0].AudioFileFormats;
                DocumentFileFormats = FormatsList[1].DocumentFileFormats;
            });
        this.estimationForm = this.formBuilder.group({
            numberOfMins: new FormControl(''),
            receiptEmail: new FormControl(''),
        })
        this.showEstimateAmount = false;
        if (this.jobdata.ref === "record") {
            this.IsAudioPlay = false;
            const response: any = await this.backendService.GetPreviousRecording().toPromise();
            var recorddetails = await this.backendService.getJSONResponse(response);
            if (recorddetails.data.recording != null) {
                if (recorddetails.data.recording.isUploaded) {
                    const parsedResponse = typeof response === 'string' ? JSON.parse(response) : response;
                    this.GlobalOutput = parsedResponse || {};
                    const filePath = parsedResponse?.data.recording.filePath;
                    this.sessionId = recorddetails.data.recording.sessionId;
                    //this.RecordingTimer = true;
                    //this.IsAudioPlay = true;
                    this.showPlayDetails = true;
                    this.originalRecordingURL = recorddetails.data.originalURL;
                    this.convertedRecordingURL = recorddetails.data.convertedURL;
                    this.recordingFileName = recorddetails?.data.recording?.filePath.split('/').pop()!;
                    if (filePath) {
                        const fileName = filePath.substring(filePath.lastIndexOf('/') + 1);
                        this.GlobalOutput['name'] = fileName.substring(0, fileName.lastIndexOf('.')) + '.mp3'; // ✅ Safe now, since it's an object
                        this.GlobalOutput['isRecording'] = true;
                    }
                    //this.ListOfOriginalFiles = []
                    this.processAudioFiles(this.GlobalOutput);
                    this.originalFile = this.GlobalOutput;
                    if (this.ListOfOriginalFiles.length > 0) {
                        this.startRecordShow = false;
                        this.pauseButtonShow = false;
                        this.stopButtonShow = true;
                        this.resumeRecordShow = true;
                        this.DisableStopRecording = true;
                        //this.showPlayDetails = false;
                    }
                    this.canUpload = true;
                    this.spinner.hide();
                    await this.getDurationByUrl(parsedResponse);
                }
                else {
                    this.spinner.hide();
                }
            }
            else {
                this.spinner.hide();
            }
        }
        window.addEventListener('offline', () => this.handleOffline());
        window.addEventListener('online', () => this.handleOnline());
        this.spinner.hide();
    }
    onInput(event: any) {
        const input = event.target.value;
        event.target.value = input.replace(/[^0-9]/g, ''); // Remove any non-numeric characters
    }
    ngAfterViewInit() {
        asyncScheduler.schedule(() => {
            this.originalDataCopy = cloneDeep(this.jobdata.data);
            //SET PREVIOUS DATA IF ANY.
            if (this.jobdata.ref === "addNotes") {
                this.notesDialogData = this.jobdata.data;
                this.notesComponent.val(this.notesDialogData.Notes);
                if (this.showCustomerNotes) {
                    this.customerNotesComponent.val(this.notesDialogData.custNotes);
                }
            } else if (this.ref === "media" || this.ref === "record") {
                this.mediaDialogData = this.jobdata.data;
                this.ListOfAudioFiles = this.mediaDialogData.ListOfAudioFiles;
                this.ListOfOriginalFiles = this.mediaDialogData.ListOfOriginalFiles;
                this.canUpload = this.mediaDialogData.canUpload;
                this.originalFile = this.mediaDialogData.originalFile;
                this.FileType = this.mediaDialogData.FileType;
                ListzipFiles = this.mediaDialogData.ListzipFiles;
                this.ListOfAudioFiles1 = this.mediaDialogData.ListOfAudioFiles1;
                this.IsMergeAudios = this.mediaDialogData.IsMergeAudios;
                this.ListOfMergeAudioFiles = this.mediaDialogData.ListOfMergeAudioFiles;
                this.MergeAudioFileNameList = this.mediaDialogData.MergeAudioFileNameList;
                //this.oneTrans.checked = this.mediaDialogData.IsMergeAudios;

            } else if (this.ref === "attachDocs") {
                this.attachmentsDialogData = this.jobdata.data;
                this.ListOfAttachments = this.attachmentsDialogData.ListOfAttachments;
                this.ListOfAttachmentFiles = this.attachmentsDialogData.ListOfAttachmentFiles;
            }
            else if (this.ref === "estimate") {
                this.getForeignLanguages();
                this.spinner.show();
                this.estimateDialogData = this.jobdata.data;
                this.estimateDialogData ? this.estimationForm.controls.numberOfMins.setValue(this.estimateDialogData.numberOfMins) : null;
                this.estimateDialogData ? this.estimationForm.controls.receiptEmail.setValue(this.estimateDialogData.receiptEmail) : null;
                this.estimateDialogData ? this.totalEstimateAmount = this.estimateDialogData.totalEstimateAmount : null;
                this.estimateDialogData ? this.showAcceptButton = this.estimateDialogData.showAcceptButton : null;
                this.numberOfMins = this.estimateDialogData ? this.estimateDialogData.numberOfMins : null;
                this.receiptEmail = this.estimateDialogData ? this.estimateDialogData.receiptEmail : null;
                setTimeout(() => {
                    if (this.estimateDialogData.selectedIndex == 0) {
                        if (this.estimateDialogData.numberOfMins == 0 || this.estimateDialogData.numberOfMins == undefined) {
                            this.showEstimateAmount = false;
                        }
                        else {
                            this.showEstimateAmount = true;
                            this.EstimatejobtypeControl.setValue({
                                'externalid': this.estimateDialogData.estimateJobTypeExtId,
                                'name': this.estimateDialogData.estimateJobTypeDisplayName,
                                'jobCostMinuteRateEstimation': this.estimateDialogData.jobCostMinuteRateEstimation
                            }
                            )
                            this.jobTypeChangeEvent(this.EstimatejobtypeControl);
                            this.jobCostMinuteRateEstimation = this.estimateDialogData.jobCostMinuteRateEstimation;
                        }
                    }
                    else {
                        if (this.estimateDialogData.numberOfMins == 0 || this.estimateDialogData.numberOfMins == undefined) {
                            this.showEstimateAmount = false;
                        } else {
                            this.estimateDialogData.selectedLanguage = (this.estimateDialogData.selectedLanguage == "") ? "--- Not Selected ---" : this.estimateDialogData.selectedLanguage;
                            var selectedLanguageIndex = this.findIndexByValue(this.estimateDialogData.selectedLanguage);
                            this.selectedLanguageIndex = selectedLanguageIndex;
                            this.showEstimateAmount = true;
                            this.ForeignLanguageControl.setValue(this.ForeignLanguagevalues[this.estimateDialogData.selectedFLlanguage])
                            this.languageControl.setValue(this.languages[this.selectedLanguageIndex]);
                            this.LoadflLanguageService(this.ForeignLanguageControl);
                            this.LoadLanguage(this.languageControl);
                            this.jobCostMinuteRateEstimation = this.estimateDialogData.jobCostMinuteRateEstimation;
                        }
                    }
                    if (this.estimateDialogData.numberOfMins == 0 || this.estimateDialogData.numberOfMins == undefined) {
                        this.showEstimateAmount = false;
                    }
                    else {
                        this.showEstimateAmount = (this.showEstimateAmount) ? true : false;
                        this.departmentControl.setValue({
                            'id': this.estimateDialogData.departmentId,
                            'name': this.estimateDialogData.deptName,
                            'deptExtId': this.estimateDialogData.deptExtId,
                            'isForeignLanguage': this.estimateDialogData.isForeignLanguage,
                            'estimationMessage': this.estimateDialogData.estimationMessage
                        })
                        this.departmentChangeEvent(this.departmentControl);
                        (this.selectedIndex == 0) ? this.jobTypeChangeEvent(this.EstimatejobtypeControl) : null;
                    }
                    this.showEstimateAmount = (this.estimateDialogData.numberOfMins == 0 || this.estimateDialogData.numberOfMins == undefined) ? false : true;
                }, 2000);
            }
        })
    }
    jobtypeValuesList = []

    findIndexByValue(value) {
        for (var i = 0; i < this.languages.length; i++) {
            if (this.languages[i].name === value) {
                return i;
            }
        }
    }
    async EstimateloadJobTypeValues(departmentId) {
        let jobTypeArray = [];
        this.jobtypeValuesList = [];
        var JobTypeDetails = await this.backendService.getDepartmentJobTypeValues(departmentId).toPromise();
        var jobtypeList = this.backendService.getJSONResponse(JobTypeDetails['data'].result);
        jobtypeList = jobtypeList.filter(item => item.externalId !== "Default");
        this.jobtypeValuesList = jobtypeList;
        for (let jobtype of jobtypeList) {
            let data = { 'id': jobtype.id, 'name': jobtype.displayName, 'externalid': jobtype.externalId, 'jobCostMinuteRateEstimation': jobtype.jobCostMinuteRateEstimation }
            jobTypeArray.push(data);
        }
        jobTypeArray.sort((a, b) => a.name.localeCompare(b.name));
        this.jobTypeOptions = jobTypeArray;
        this.jobTypefilteredOptions = this.EstimatejobtypeControl.valueChanges
            .pipe(
                startWith(''),
                map(value => typeof value === 'string' ? value : value['name']),
                map(name => name ? this.jobTypefilter(name) : this.jobTypeOptions.slice()),
            );
        if (this.jobTypeOptions.length == 1) {
            this.EstimatejobtypeControl.setValue(this.jobTypeOptions[0]);
            this.EstimatejobtypeControl.disable({ onlySelf: true });
            this.selectedJobTypeExtId = this.jobTypeOptions[0].externalid;
            this.selectedJobTypeDisplayName = this.jobTypeOptions[0].name;
        }
    }
    private jobTypefilter(name: any): dropdownmodel[] {
        const filterValue = name.toLowerCase();
        return this.jobTypeOptions.filter(option => option.name.toLowerCase().indexOf(filterValue) >= 0);
    }
    jobTypeChangeEvent(event: any): void {
        if (event) {
            this.selectedJobTypeExtId = event.externalid;
            this.selectedJobTypeDisplayName = event.name;
            this.jobCostMinuteRateEstimation = event.jobCostMinuteRateEstimation;
        }
        if (this.showEstimateAmount == true) {
            this.selectedJobTypeExtId = event.value.externalid;
            this.selectedJobTypeDisplayName = event.value.name;
            this.jobCostMinuteRateEstimation = event.value.jobCostMinuteRateEstimation;
        }
    };
    jobtypeChange() {
        this.selectedJobTypeExtId = '';
        this.selectedJobTypeDisplayName = '';
        this.EstimatejobtypeControl.setValue('');
        this.showEstimateAmount = false;
    }
    changeMinutes() {
        this.showEstimateAmount = false;
    }
    GenerateEstimate() {
        this.selectedIndex = this.isForeignLanguage == true ? 1 : 0;
        console.log("this.selectedIndex:::", this.selectedIndex);
        this.numberOfMins = this.estimationForm.controls.numberOfMins.value;
        this.receiptEmail = this.estimationForm.controls.receiptEmail.value;
        this.estimateDateTime = this.getCurrentDateTime();

        if (this.selectedIndex == 0) {
            this.spinner.show();
            if (this.selectedDepartmentId.trim() == '') {
                this.sendNotification("Please select a Department.", 'error');
            }
            else if (this.selectedJobTypeDisplayName == "" || this.selectedJobTypeDisplayName == null) {
                this.sendNotification("Please select Job type.", "error");
            }
            else if (this.numberOfMins == 0 || this.numberOfMins == null) {
                this.sendNotification("Please enter Number of minutes of Audio.", "error");
            }
            else {
                if (this.jobCostMinuteRateEstimation == null || Number(this.jobCostMinuteRateEstimation) == 0) {
                    this.mode = "jobCostMinuteRateEstimationNull";
                    this.sweetalertForEstimateWarnings();
                }
                else {
                    console.log("Number(this.jobCostMinuteRateEstimation)", Number(this.jobCostMinuteRateEstimation));
                    this.totalEstimateAmount = this.numberOfMins * Number(this.jobCostMinuteRateEstimation);
                    const formattedTotalEstimateAmount: string = this.totalEstimateAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                    if (this.totalEstimateAmount > 0) {
                        this.showEstimateAmount = true;
                        console.log("this.receiptEmail:::", this.receiptEmail);
                        if (this.receiptEmail == "" || this.receiptEmail == undefined) {
                            console.log("this.receiptEmail field is empty");
                        }
                        else {
                            const data = {
                                'toEmail': this.receiptEmail,
                                'numberofMinutesforEstimation': this.numberOfMins,
                                'perMinuteEstimationRate': (Number(this.jobCostMinuteRateEstimation)),
                                'totalEstimationCost': formattedTotalEstimateAmount,
                                'estimateDateTime': this.estimateDateTime
                            }
                            this.backendService.SendEstimationEmail(data).subscribe(
                                (response) => {
                                    console.log('Email sent successfully', response);
                                },
                                (error) => {
                                    console.error('Error sending email', error);
                                }
                            );
                            this.sendNotification("The estimation details were sent to the receipt email.", "success");
                        }
                    }
                }
            }
            this.spinner.hide();
        }
        else {
            if (this.selectedDepartmentId.trim() == '') {
                this.sendNotification("Please select a Department.", 'error');
            }
            else if (this.flLanguageService == 0) {
                this.sendNotification("Please select Foreign Language Order.", "error");
            }
            else if (this.selectedLanguage == undefined || this.selectedLanguage == "" || this.selectedLanguage == "--- Not Selected ---") {
                this.sendNotification("Please select Language.", "error");
            }
            else if (this.selectedLanguage != "" && this.selectedLanguage != "Spanish") {
                this.mode = "selectedLanguageNotEmpty";
                this.sweetalertForEstimateWarnings();
            }
            else if (this.numberOfMins == 0 || this.numberOfMins == null) {
                this.sendNotification("Please enter Number of minutes of Audio.", "error");
            }
            else if (this.flLanguageService == 1) {
                this.mode = "flLanguageServiceValue1";
                this.sweetalertForEstimateWarnings();
            }
            else {
                this.spinner.show();
                const data = {
                    'fLServiceType': this.flLanguageService,
                    'language': this.selectedLanguage,
                }
                this.backendService.getflratebylanguage(data).subscribe(
                    (response: any) => {
                        this.FlCostMinuteRateEstimation = response.data.flRate;
                        this.jobCostMinuteRateEstimation = this.FlCostMinuteRateEstimation;
                        this.totalEstimateAmount = this.numberOfMins * Number(this.jobCostMinuteRateEstimation);
                        const formattedTotalEstimateAmount: string = this.totalEstimateAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                        this.showEstimateAmount = true;
                        if (this.receiptEmail == "" || this.receiptEmail == undefined) {
                            console.log("this.receiptEmail field is empty");
                        }
                        else {
                            const data = {
                                'toEmail': this.receiptEmail,
                                'numberofMinutesforEstimation': this.numberOfMins,
                                'perMinuteEstimationRate': (Number(this.FlCostMinuteRateEstimation)),
                                'totalEstimationCost': formattedTotalEstimateAmount,
                                'estimateDateTime': this.estimateDateTime
                            }
                            this.backendService.SendEstimationEmail(data).subscribe(
                                (response) => {
                                    console.log('Email sent successfully', response);
                                },
                                (error) => {
                                    console.error('Error sending email', error);
                                }
                            );
                            this.sendNotification("The estimation details were sent to the receipt email.", "success");
                        }
                        this.spinner.hide();
                    },
                    (error) => {
                        console.error('Error while fetching flrate', error);
                    }
                );
            }
        }
        this.showAcceptButton == (this.showEstimateAmount) ? true : false;
    }
    getCurrentDateTime(): string {
        const now = new Date();
        return this.datePipe.transform(now, 'dd-MMM-yyyy HH:mm:ss') || '';
    }
    getTermsAndConditions() {
        this.backendService.getTermsAndConditionByTenant(localStorage.getItem('tenantId')).subscribe(
            res => {
                this.termsAndConditionData = JSON.parse(res['data'].tncjson);
                this.spinner.hide();
            },
            err => {
                console.log("error result :::", err.error.message)
                let errorResult = err.error.message;
                this.sendNotification(errorResult, 'error')
                this.spinner.hide();
            })
    }
    viewTnC(event: any) {
        this.openViewTNC(this.termsAndConditionData);
    }
    openViewTNC(tnc): void {
        if (this.ViewTnCdialogRef == null) {
            this.ViewTnCdialogRef = this.dialog.open(ViewTNCComponent, {
                width: '50%',
                maxHeight: '90vh',
                data: { "tnc": tnc },
                disableClose: false,
                panelClass: 'my-dialog'
            });
            this.ViewTnCdialogRef.afterClosed().subscribe(result => {
                this.ViewTnCdialogRef = null;
            });
        }
    }
    tabClick(tab) {
        this.selectedIndex = tab.index;
        if (this.selectedIndex == 1) {
            this.ForeignLanguageControl.setValue(this.ForeignLanguagevalues[this.estimateDialogData.selectedFLlanguage])
            this.languageControl.setValue(this.languages[this.selectedLanguageIndex]);
            this.estimationForm.controls.numberOfMins.setValue(this.numberOfMins);
            this.estimationForm.controls.receiptEmail.setValue(this.receiptEmail);
            this.jobCostMinuteRateEstimation = "";
            this.showEstimateAmount = (this.numberOfMins == null) ? false : true;
        }
        else {
            this.estimationForm.controls.numberOfMins.setValue(this.numberOfMins);
            this.estimationForm.controls.receiptEmail.setValue(this.receiptEmail);
            this.showEstimateAmount = (this.numberOfMins == null) ? false : true;
            this.EstimatejobtypeControl.setValue({
                'externalid': this.selectedJobTypeExtId[0],
                'name': this.selectedJobTypeDisplayName[0]
            })
        }

    }
    async getForeignLanguages() {
        await this.backendService.getForeignLanguages().subscribe(
            res => {
                const result = this.backendService.getJSONResponse(res);
                this.languages = result['data'].proEditLanguages;
                // Setup filtering logic after data is available
                this.languageControl.valueChanges
                    .pipe(
                        startWith(''),
                        map(value => (typeof value === 'string' ? value : value?.name)),
                        map(name => (name ? this._filterLanguages(name) : this.languages.slice()))
                    )
                    .subscribe(filtered => {
                        this.filteredLanguages = filtered;
                    });
            },
            err => {
                const er = this.backendService.getJSONResponse(err);
                this.backendService
                    .AWSLog("error", "Problem occurred while fetching ForeignLanguages. Error: " + err)
                    .subscribe();
                this.spinner.hide();
            }
        );
    }
    private _filterLanguages(name: string): any[] {
        const filterValue = name.toLowerCase();
        return this.languages.filter(lang => lang.name.toLowerCase().includes(filterValue));
    }
    languageChange() {
        this.selectedLanguage = '';
        this.showEstimateAmount = false;
    }
    languageChangeEvent(value: any) {
        console.log("value:::", value)
        this.selectedLanguage = value.option.value.name;
        if (this.selectedLanguage == "--- Not Selected ---" || this.selectedLanguage == "") {
            this.sendNotification("Select a Language", 'error');
        }
        else if (this.selectedLanguage != "" && this.selectedLanguage != "Spanish") {
            this.mode = "selectedLanguage";
            this.sweetalertForEstimateWarnings();
        }
    }
    LoadLanguage(value: any) {
        this.selectedLanguage = value.value.name;
        if (this.selectedLanguage == "--- Not Selected ---" || this.selectedLanguage == "") {
            this.sendNotification("Select a Language", 'error');
        }
        else if (this.selectedLanguage != "" && this.selectedLanguage != "Spanish") {
            this.mode = "selectedLanguage";
            this.sweetalertForEstimateWarnings();
        }
    }
    isValid(controlName, error) {
        return this.estimationForm.controls[controlName] && this.estimationForm.controls[controlName].hasError(error);
    }
    AcceptEstimate() {
        console.log("Accept Estimate...");
        this.estimateDialogData.jobCostMinuteRateEstimation = this.jobCostMinuteRateEstimation;
        this.estimateDialogData.totalEstimateAmount = this.totalEstimateAmount;
        this.estimateDialogData.numberOfMins = this.numberOfMins;
        this.estimateDialogData.receiptEmail = this.receiptEmail;
        this.estimateDialogData.isForeignLanguage = this.isForeignLanguage;
        this.estimateDialogData.departmentId = this.selectedDepartmentId;
        this.estimateDialogData.deptName = this.deptName;
        this.estimateDialogData.deptExtId = this.deptExtId;
        this.estimateDialogData.estimationMessage = this.DisplayEstimationMessage;
        this.selectedIndex = this.isForeignLanguage == true ? 1 : 0;
        this.estimateDialogData.selectedIndex = this.selectedIndex;
        if (this.selectedDepartmentId.trim() == '') {
            this.sendNotification("Please select a Department.", 'error');
        }
        if (this.selectedIndex == 0) {
            this.estimateDialogData.estimateJobTypeDisplayName = this.selectedJobTypeDisplayName;
            this.estimateDialogData.estimateJobTypeExtId = this.selectedJobTypeExtId;
            this.dialogRef.close(this.estimateDialogData);
            this.sendNotification("Estimate Accepted", "success");
        }
        else {
            if (this.totalEstimateAmount < 150 || this.totalEstimateAmount == 0) {
                this.mode = "totalEstimateAmountLessthen150";
                this.sweetalertForEstimateWarnings();
            }
            else if (this.selectedLanguage != "" && this.selectedLanguage != "Spanish") {
                this.mode = "selectedLanguageNotEmpty";
                this.sweetalertForEstimateWarnings();
                this.estimateDialogData.selectedLanguage = "";
                this.estimateDialogData.selectedFLlanguage = 0;
                this.estimateDialogData.jobCostMinuteRateEstimation = null;
                this.estimateDialogData.totalEstimateAmount = null;
                this.estimateDialogData.numberOfMins = null;
                this.estimateDialogData.receiptEmail = null;
            }
            else {
                this.estimateDialogData.selectedLanguage = this.selectedLanguage;
                this.estimateDialogData.selectedFLlanguage = this.flLanguageService;
                this.dialogRef.close(this.estimateDialogData);
                this.sendNotification("Estimate Accepted", "success");
            }
        }

    }
    fllanguageChange() {
        this.flLanguageService = 0;
        this.showEstimateAmount = false;
    }
    flLanguageChangeEvent(event) {
        this.flLanguageService = event.option.value.value;
        if (this.flLanguageService == 1) {
            this.mode = "flLanguageServiceValue1";
            this.sweetalertForEstimateWarnings();
        }
        if (this.flLanguageService == 0) {
            this.sendNotification("Select a Foreign Language", 'error');
        }
    }
    LoadflLanguageService(val) {
        this.flLanguageService = val.value.value;
        if (this.flLanguageService == 1) {
            this.mode = "flLanguageServiceValue1";
            this.sweetalertForEstimateWarnings();
        }
        if (this.flLanguageService == 0) {
            this.sendNotification("Select a Foreign Language", 'error');
        }
    }



    displayFn(dropdownmodel: dropdownmodel): string {
        return dropdownmodel && dropdownmodel.name ? dropdownmodel.name : '';
    }
    displayFnFL(ForeignLanguagevalues: any): string {
        return ForeignLanguagevalues ? ForeignLanguagevalues.name : '';
    }
    displayFnLanguage(language?: any): string | undefined {
        return language ? language.name : '';
    }

    fileOver(event) {
        console.log('fileOver event : ' + event);
    }

    fileLeave(event) {
        console.log('fileLeave event : ' + event);
    }

    getFilesCount(): number {
        if (this.ref === "attachDocs") {
            return this.ListOfAttachments.length ? this.ListOfAttachments.length : 0;
        }
        else if (this.ref === "media" || this.ref === "record") {
            return this.ListOfAudioFiles.length ? this.ListOfAudioFiles.length : 0;
        }
    }
    async removeFileByName(fileName: string) {

  if (this.IsMergeAudios) {
    this.remove();
    return;
  }
if (this.jobdata.ref === "media") {

    const file = this.ListOfOriginalFiles.find(x => x.name === fileName);

    if (file && !file.isRecording) {

      this.ListOfOriginalFiles = this.ListOfOriginalFiles.filter(f => f.name !== fileName);
      this.ListOfAudioFiles = [...this.ListOfOriginalFiles];

      if (this.ListOfAudioFiles.length === 0) {
        this.canUpload = true;
        this.ListOfOriginalFiles = [];
        ListzipFiles = [];
      }

      this.canUpload = true;
      this.file = null;
      this.originalFile = null;
      return;
    }

    if (file && file.isRecording) {
      this.mode = "RemoveFileName";
      this.sessionId = file.data.recording.sessionId;
      this.sweetalert(fileName, null);
      return;
    }
  }

  this.mode = "RemoveFileName";
  this.sweetalert(fileName, null);
}

    async removeFileName(fileName) {
        const ListAfterRemove = [];
        for (const filedetails of this.ListOfOriginalFiles) {
            try {
                const response: any = await this.backendService.UpdateRecording(this.sessionId).toPromise();
                if (response) {
                    if (filedetails.name !== fileName) {
                        ListAfterRemove.push(filedetails);
                    }
                }
            } catch (err) {
                console.error("UpdateRecording", err);
                this.spinner.hide();
            }
        }
        this.ListOfOriginalFiles = ListAfterRemove;
        this.ListOfAudioFiles = ListAfterRemove;
        if (this.ListOfAudioFiles.length === 0) {
            this.canUpload = false;
            this.ListOfOriginalFiles = [];
            ListzipFiles = [];
        }
        this.startRecordShow = true;
        this.pauseButtonShow = false;
        this.stopButtonShow = false;
        this.resumeRecordShow = false;
        this.file = null;
        this.originalFile = null;
        this.RecordingTimer = false;
        this.IsAudioPlay = false;
        clearInterval(this.interval);
        this.fileCount = 0;
        this.ListOfOriginalFiles = [];
        ListzipFiles = [];
        this.ListOfAudioFiles = [];
        this.DisableStopRecording = false;
        this.showPlayDetails = false;
        this.spinner.hide();

    }
    removeAttachmentByName(fileName) {
        var ListofAttachmentsAfterRemove = [];
        var ListOfAttachmentFilesAfterRemove = [];
        this.ListOfAttachments.forEach(filedetails => {
            if (filedetails.fileName == fileName) {
            }
            else {
                ListofAttachmentsAfterRemove.push(filedetails);
            }
        });
        this.ListOfAttachments = ListofAttachmentsAfterRemove;

        this.ListOfAttachmentFiles.forEach(filedetails => {
            if (filedetails.filename == fileName) {
            }
            else {
                ListOfAttachmentFilesAfterRemove.push(filedetails);
            }
        });
        this.ListOfAttachmentFiles = ListOfAttachmentFilesAfterRemove;
        ListOfZippedDocuments = this.ListOfAttachments;
        if (this.ListOfAttachments.length == 0) {
            this.canUpload = false;
        }
        console.log("removeAttachmentByName ListOfAttachments", this.ListOfAttachments);
        console.log("removeAttachmentByName ListOfAttachmentFiles", this.ListOfAttachmentFiles);
    }
    public async dropped(files: NgxFileDropEntry[]) {
        console.log("dropped started...", this.showAttachment);

        this.exceedFileLimit = this.ListOfAudioFiles.length == 0 ? false : this.exceedFileLimit;
        ListzipFiles = [];
        var fileNumber = 0;
        this.fileCount = 0;
        this.spinner.show();
        for (const droppedFile of files) {
            // Is it a file?
            //check for Media/Attachment
            if (this.ref == "media") {
                if (droppedFile.fileEntry.isFile) {
                    if (fileNumber == 0) {
                        this.fileCount = this.ListOfAudioFiles.length;
                    }
                    this.fileCount = this.fileCount + 1;
                    fileNumber = fileNumber + 1;
                    if (this.fileCount > this.maxNumberOfFiles && this.IsMergeAudios) {
                        this.exceedFileLimit = true;
                    }
                    else {
                        this.isDuplicate = false;
                        const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
                        fileEntry.file((file: File) => {
                            this.file = file;
                            this.originalFile = file;
                            this.FileType = file.name.split(/[.;+_]/).pop().toLowerCase();
                            file["isRecording"] = false;
                            if (!this.isjob && this.IsMergeAudios == true && this.FileType == "zip") {
                                this.spinner.hide();
                            }
                            else {
                                if (this.originalFile.size > fileMinSize) {
                                    if (this.FileType === "mp3" || this.FileType === "wav" || this.FileType === "mp2" || this.FileType === "m4a" || this.FileType === "m4v" || this.FileType === "dss" || this.FileType === "ds2" || this.FileType === "aac" || this.FileType === "wma" || this.FileType === "oga" || this.FileType === "trm" || this.FileType === "mp4" || this.FileType === "m4v" || this.FileType === "opus" || this.FileType === "avi" || this.FileType === "ogg" || this.FileType === "mkv" || this.FileType === "wmv" || this.FileType === "vob" || this.FileType === "mov" || this.FileType === "mts" || this.FileType === "zip" || this.FileType === "mod") {
                                        //////For Zip format
                                        if (this.FileType === "zip") {
                                            this.canUpload = true;
                                            this.ListOfOriginalFiles = [];
                                            this.ListOfZipFiles = [];
                                            this.ListZipFailedFiles = "";
                                            console.log("zip file........");
                                            var new_zip = new JSZip();
                                            new_zip.loadAsync(this.originalFile)
                                                .then((zip) => {
                                                    var count = 0;
                                                    zip.forEach(fileContent => {
                                                        count = count + 1;
                                                        if (fileContent.includes("/")) {
                                                            if (count > 1) {
                                                                zip.file(fileContent).async("blob").then(async function (filedata: any) {
                                                                    var fName = fileContent.substring(fileContent.lastIndexOf("/") + 1);
                                                                    var fileExtension = fName.split(/[.;+_]/).pop().toLowerCase();
                                                                    console.log("this.AudioFileFormats1::::", AudioFileFormats);

                                                                    //check Audio file extension 
                                                                    var ValidAudioExtension = AudioFileFormats.filter(x => x == fileExtension);
                                                                    fName = fName.split('.').slice(0, -1).join('.')
                                                                    fName = fName.replace(/[^a-zA-Z0-9]/g, ' ');
                                                                    fName = fName.replace(/\s\s+/g, ' ');
                                                                    fName = fName.trim();
                                                                    fName = fName.replace(/[^a-zA-Z0-9]/g, '_');
                                                                    fName = fName + "." + fileExtension;

                                                                    filedata["name"] = fName;
                                                                    filedata["FileName"] = fName;
                                                                    filedata["fileName"] = fName;
                                                                    if (ValidAudioExtension.length > 0) {
                                                                        console.log("Process audio files...Foldered Zip");
                                                                        if (filedata.size > fileMinSize) {
                                                                            zipFile = filedata;
                                                                            this.ListzipFiles.push(zipFile);
                                                                        }
                                                                        else {
                                                                            if (this.ListZipFailedFiles == "") {
                                                                                this.ListZipFailedFiles = filedata.name;
                                                                            }
                                                                            else {
                                                                                this.ListZipFailedFiles = this.ListZipFailedFiles + "," + filedata.name;
                                                                            }
                                                                        }

                                                                    }
                                                                    //check document file formats
                                                                    var ValidDocumentExtension = DocumentFileFormats.filter(x => x == fileExtension);
                                                                    if (ValidDocumentExtension.length > 0) {
                                                                        filedata["fileName"] = fName;
                                                                        filedata["filename"] = fName;
                                                                        this.Audiofile = new FileToUpload();
                                                                        this.Audiofile.fileName = fName;
                                                                        this.Audiofile.fileSize = 10;
                                                                        this.Audiofile.fileType = "application/" + fileExtension;
                                                                        this.Audiofile.lastModifiedTime = Date.now();
                                                                        var dateevent = new Date();
                                                                        this.Audiofile.lastModifiedDate = dateevent;
                                                                        ListOfZippedDocuments.push(this.Audiofile);
                                                                        this.ListOfAttachmentFiles.push(filedata);
                                                                    }
                                                                });
                                                            }
                                                        }
                                                        else {
                                                            zip.file(fileContent).async("blob").then(async function (filedata) {
                                                                var fName = fileContent;
                                                                var fileExtension = fName.split(/[.;+_]/).pop().toLowerCase();
                                                                console.log("this.AudioFileFormats2::::", AudioFileFormats);

                                                                //check Audio file extension 
                                                                var ValidAudioExtension = AudioFileFormats.filter(x => x == fileExtension);
                                                                fName = fName.split('.').slice(0, -1).join('.')
                                                                fName = fName.replace(/[^a-zA-Z0-9]/g, ' ');
                                                                fName = fName.replace(/\s\s+/g, ' ');
                                                                fName = fName.trim();
                                                                fName = fName.replace(/[^a-zA-Z0-9]/g, '_');
                                                                fName = fName + "." + fileExtension;
                                                                filedata["name"] = fName;
                                                                filedata["FileName"] = fName;
                                                                filedata["fileName"] = fName;
                                                                console.log("separate files ...", filedata);
                                                                if (ValidAudioExtension.length > 0) {
                                                                    console.log("Process audio files...Seperate zipfiles");
                                                                    if (filedata.size > fileMinSize) {
                                                                        zipFile = filedata;
                                                                        ListzipFiles.push(zipFile);
                                                                        console.log("ListzipFiles.push", ListzipFiles);
                                                                    }
                                                                    else {
                                                                        if (this.ListZipFailedFiles == "") {
                                                                        }
                                                                        else {
                                                                        }
                                                                    }
                                                                }
                                                                //check document file formats
                                                                var ValidDocumentExtension = DocumentFileFormats.filter(x => x == fileExtension);
                                                                if (ValidDocumentExtension.length > 0) {
                                                                    filedata["fileName"] = fName;
                                                                    filedata["filename"] = fName;
                                                                    this.Audiofile = new FileToUpload();
                                                                    this.Audiofile.fileName = fName;
                                                                    this.Audiofile.fileSize = 10;
                                                                    this.Audiofile.fileType = "application/" + fileExtension;
                                                                    this.Audiofile.lastModifiedTime = Date.now();
                                                                    var dateevent = new Date();
                                                                    this.Audiofile.lastModifiedDate = dateevent;
                                                                    ListOfZippedDocuments.push(this.Audiofile);
                                                                    this.ListOfAttachmentFiles.push(filedata);
                                                                }
                                                            });
                                                        }
                                                    });
                                                });
                                            setTimeout(() => {
                                                if (this.ListZipFailedFiles !== "") {
                                                    this.sendNotification(this.ListZipFailedFiles + ' file(s) are less than 0 kb size.  Please upload files with mininum 5kb size.', 'error');
                                                }
                                            }, 1500);
                                            this.ListOfZipFiles.push(this.originalFile);
                                            this.canUpload = true;
                                            this.ListOfAudioFiles = ListzipFiles;
                                            this.ListOfAttachments = ListOfZippedDocuments;
                                            this.spinner.hide();
                                        }
                                        ///////Normal audio files
                                        else {
                                            if (this.IsMergeAudios) {
                                                if (this.MergeAudioFormat == null || this.MergeAudioFormat == "" || this.MergeAudioFormat == "undefined") {
                                                    this.MergeAudioFormat = this.FileType;
                                                }
                                                if (this.MergeAudioFormat == this.FileType || (this.MergeAudioFormat == null || this.MergeAudioFormat == "" || this.MergeAudioFormat == "undefined")) {
                                                    //console.log("merge Audios");
                                                    if (!this.exceedFileLimit) {
                                                        this.processAudioFiles(file);
                                                        //console.log("this.isDuplicate", this.isDuplicate);
                                                    }
                                                }
                                                else {
                                                    this.sendNotification('Please select the ' + this.MergeAudioFormat + ' format files to Merge.', 'error');
                                                }
                                            }
                                            else {
                                                this.ListOfDuplicateFiles = [];
                                                this.DuplicateFileNames = null;

                                                this.backendService.isfileexist(file.name).subscribe(
                                                    res => {
                                                        const fileResult = this.backendService.getJSONResponse(res);
                                                        if (!fileResult.data.fileNameExist) {
                                                            this.isDuplicate = false;
                                                            this.processAudioFiles(file);
                                                        }
                                                        else {
                                                            this.ListOfDuplicateFiles.push(file);
                                                            if (this.DuplicateFileNames == null) {
                                                                this.DuplicateFileNames = file.name;
                                                            }
                                                            else {
                                                                this.DuplicateFileNames = this.DuplicateFileNames + ", " + file.name;
                                                            }
                                                            console.log("DuplicateFileNames", this.DuplicateFileNames);
                                                        }
                                                        if (fileNumber == files.length) {
                                                            if (this.ListOfDuplicateFiles.length > 0) {
                                                                this.mode = "CheckFileName";
                                                                this.sweetalert(null, null);
                                                                this.spinner.hide();
                                                            }
                                                            else {
                                                                this.spinner.hide();
                                                            }
                                                        }
                                                    },
                                                    err => {
                                                        const er = this.backendService.getJSONResponse(err);
                                                        this.sendNotification('Problem occurred while checking audiofile exist. ' + JSON.stringify(er), 'error');
                                                        this.backendService.AWSLog("error", "Problem occurred while checking audiofile exist.: " + err).subscribe();
                                                        this.spinner.hide();
                                                    }
                                                );
                                            }
                                        }
                                    }
                                    else {
                                        this.sendNotification('Selected file is ' + this.FileType + '. Please upload files with mp2, mp3, wav, m4a, dss, ds2, aac, wma, oga, trm, mts,mod and zip formats.', 'error');
                                        this.spinner.hide();
                                    }
                                    if (this.IsMergeAudios) {
                                        if (this.FileType != "zip") {
                                            this.ListOfAudioFiles = [];
                                            this.ListOfAudioFiles = this.ListOfMergeAudioFiles;
                                        }
                                        this.spinner.hide();
                                    }
                                }
                                else {
                                    this.sendNotification('Please upload files with mininum 5kb size.', 'error');
                                }
                            }
                        })
                    }
                }

            }
            else if (this.ref == "attachDocs") {
                // this.spinner.show();
                const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
                fileEntry.file((file: File) => {
                    //check for file size for attachments. Handle the size
                    var fileSize = file.size;
                    var maxSize = 314572800;
                    if (fileSize > maxSize) {
                        this.sendNotification("The maximum attachment size is 300 MB. Please upload files smaller than 300 MB. ", 'error');
                        this.spinner.hide();
                        return;
                    }
                    var filenamewithoutextension = file.name.substr(file.name.lastIndexOf('\\') + 1);
                    filenamewithoutextension = filenamewithoutextension.substr(0, filenamewithoutextension.lastIndexOf('.'));
                    let noWhiteSpace = filenamewithoutextension.replace(/ /g, "_");
                    var desiredFilename = noWhiteSpace.replace(/[^\w\s]/gi, '')
                    let Fileextension = file.name.split(/[.;+_]/).pop().toLowerCase();
                    var desiredFileNameWithExtension = desiredFilename + "." + Fileextension;
                    const isDuplicate = this.ListOfAttachments.some(filedetails => filedetails.fileName === desiredFileNameWithExtension);
                    if (!isDuplicate) {
                        file["filename"] = desiredFileNameWithExtension;


                        this.ListOfAttachmentFiles.push(file);
                        this.readAndUploadAttachmentFile(file);
                    } else {
                        this.sendNotification(`${file.name} is already exist.`, "error");
                        this.spinner.hide();
                    }
                })
            }

        }
        if (this.IsMergeAudios == true && this.FileType == "zip") {
            this.spinner.show();
            console.log("ismerge", this.IsMergeAudios);
            if (!this.isjob) {
                this.sendNotification('Uploading ZIP folders is not supported. Please upload individual files instead', 'error')
            }
            else {
                this.mode = "CheckOTForZip";
                this.sweetalert(null, null);
            }
        };
    }

    processAudioFiles(file) {
        this.ListOfZipFiles = [];
        ///Duplicate filename  verification
        this.ListOfOriginalFiles.forEach(filedetails => {
            if (filedetails.name == file.name) {
                this.isDuplicate = true;
            }
        })
        if (this.PrevioussessionId != "") {
            this.ListOfOriginalFiles.push(file);
        }
        else {
            if (this.isDuplicate == true) {
                if (!file.isRecording) {
                    this.sendNotification(file.name + " is already exist.", "error");
                    this.fileCount = this.fileCount - 1;
                }
            }
            else {
                if (this.ListOfNames == "") {
                    this.ListOfNames = file.name;
                }
                else {
                    this.ListOfNames = this.ListOfNames + ", " + file.name;
                }
                this.ListOfOriginalFiles.push(file);
                if (this.IsMergeAudios == true) {
                    this.readAndUploadAudioFile(file);
                }
                this.canUpload = true;
            }
        }
        this.ListOfAudioFiles = this.ListOfOriginalFiles;
        // Limit the uploaded files to 100
        if (this.ListOfAudioFiles.length > this.maxNumberOfFiles && this.IsMergeAudios) {
            this.exceedFileLimit = true;
            console.log("this.exceedFileLimit", this.exceedFileLimit);
        }
        return this.isDuplicate;
    }

    sweetalertForEstimateWarnings() {

        var reqsubstring = "";
        if (this.mode == "jobCostMinuteRateEstimationNull") {
            reqsubstring = "The selected job type does not have an estimated cost. So, please config cost estimation rate for this Job type in NetScribe.";
        }
        if (this.mode == "selectedLanguageNotEmpty") {
            reqsubstring = " We are unable to provide an automated estimate at this time for that language - please contact sales@viqsolutions.com.";
        }
        if (this.mode == "flLanguageServiceValue1") {
            reqsubstring = "This service is included in the normal rate of your transcription request for that turnaround time.";
        }
        if (this.mode == "totalEstimateAmountLessthen150") {
            reqsubstring = "The estimation cost is less than 150$.";
        }
        if (this.mode == "selectedLanguage") {
            reqsubstring = "We are unable to provide an automated estimate at this time for that language - please contact sales@viqsolutions.com.";
        }
        Swal.fire({
            title: 'Warning',
            text: reqsubstring,
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `Ok`,
            cancelButtonText: `No`,
            denyButtonText: `Cancel`,
            confirmButtonColor: '#187EB1',
            cancelButtonColor: '#5b5b5b',
        }).then((result) => {
        })
    }
    sweetalert(fileName, action) {

        var reqsubstring = "";
        if (this.mode == "CheckFileName") {
            reqsubstring = "It appears that you have already uploaded this audio file " + this.DuplicateFileNames + " for a different job.  Are you sure you want to upload this file?";
        }
        if (this.mode == "CheckOTForZip") {
            reqsubstring = "When uploading a .zip file, each file will result in its own transcription. They cannot be merged into One Transcript. Do you want to continue with Separate Transcripts?"
        }
        if (this.mode == "StopRecording") {
            reqsubstring = "Are you sure, you want to stop and submit the recording?";
        }
        if (this.mode == "ChangeTranscriptionType") {
            reqsubstring = "Are you sure, you want to change the transcription type? Please note that all the selected/recorded Audio/Video files will be deleted after the change. ";
        }
        if (this.mode == "ResumeRecording") {
            reqsubstring = "Already, you have one recorded file. ";
        }
        if (this.mode == "RemoveFileName" || this.mode == "RemoveFileForDialogClose") {
            reqsubstring = "Are you sure, you want to remove recording file. ";
        }
        Swal.fire({
            title: 'Confirmation',
            text: reqsubstring,
            showDenyButton: false,
            showCancelButton: true,
            confirmButtonText: `Yes`,
            cancelButtonText: `No`,
            denyButtonText: `Cancel`,
            confirmButtonColor: '#187EB1',
            cancelButtonColor: '#5b5b5b',
        }).then((result) => {
            if (result.value) {
                if (this.mode == "CheckFileName") {
                    this.ListOfDuplicateFiles.forEach(element => {
                        this.processAudioFiles(element);
                    });
                }
                if (this.mode == "CheckOTForZip") {
                    console.log("CheckOTForZip", result.value);
                    this.IsMergeAudios = false;
                    this.IsMergeAudiosGlobal = false;
                    console.log("ListOfAudioFiles", this.ListOfAudioFiles);
                    console.log("ListzipFiles", ListzipFiles);
                    this.spinner.hide();
                }
                if (this.mode == "StopRecording") {
                    this.spinner.show();
                    // this.hr = '0' + 0;
                    // this.min = '0' + 0;
                    // this.sec = '0' + 0;
                    clearInterval(this.interval);
                    // this.resumeRecordShow = true;
                    this.stopRecordingAndUpload();
                    //this.StopRecordingprocess();
                }
                if (this.mode == "ChangeTranscriptionType") {
                    this.TranscriptionTypeChange();
                }
                if (this.mode == "RemoveFileName") {
                    this.spinner.show();
                    this.removeFileName(fileName);
                }
                if (this.mode == "RemoveFileForDialogClose") {
                    this.spinner.show();
                    this.removeFileFromDialogClose(action);
                }
            }
            if (result.isDismissed) {
                if (this.mode == "CheckOTForZip") {
                    console.log("CheckOTForZip isDismissed", result.isDismissed);
                    this.remove();
                    this.spinner.hide();
                }
                if (this.mode == "StopRecording") {
                    //this.pauseRecording();
                    // this.resumeRecordShow = false;
                    // this.pauseButtonShow = true;
                }

                //If the transcription type change is cancelled then we should reverse the change.
                if (this.mode == "ChangeTranscriptionType") {
                    if (this.transcriptionType == 1) {
                        //one Transcript
                        this.IsMergeAudios = true;
                        this.oneTrans.focus();
                        this.oneTrans.checked = true;
                    }
                    else if (this.transcriptionType == 2) {
                        //Individual Transcripts
                        this.IsMergeAudios = false;
                        this.sepTrans.focus();
                        this.sepTrans.checked = true;
                    }
                    this.transcriptionType = undefined;
                }
            }
        })
    }
    OnclickStartButton() {
        this.pauseButtonShow = !this.pauseButtonShow;
        this.stopButtonShow = !this.stopButtonShow;
        this.startRecordShow = false;
    }

    RecordingTime() {
        this.interval = setInterval(() => {
            this.sec++
            this.sec = this.sec < 10 ? '0' + this.sec : this.sec;
            if (this.sec === 60) {
                this.min++
                this.min = this.min < 10 ? '0' + this.min : this.min;
                this.sec = '0' + 0;
            }
            if (this.min === 60) {
                this.hr++
                this.hr = this.hr < 10 ? '0' + this.hr : this.hr;
                this.min = '0' + 0;
            }
        }, 1000)
    }

    sendNotification(message, messageType) {
        this.msgNotification.elementRef.nativeElement.querySelector('.jqx-notification-content').innerHTML = message;
        this.msgNotification.template(messageType);
        this.msgNotification.open();
    }

    getJSONResponse(value: any) {
        return JSON.parse(JSON.stringify(value));
    }

    removeJobAudioFiles() {
        this.ListOfAudioFiles = [];
    }

    clear() {
        this.removeJobAudioFiles();
    }

    async dialogClose(action: string) {
        if (this.ref === "attachDocs") {
            this.attachmentsDialogData.ListOfAttachments = this.originalDataCopy.ListOfAttachments;
            this.attachmentsDialogData.ListOfAttachmentFiles = this.originalDataCopy.ListOfAttachmentFiles;
            this.dialogRef.close(this.attachmentsDialogData);
        }
        else if (this.ref === "media" || this.ref === "record") {
            this.mediaDialogData.ListOfOriginalFiles = this.originalDataCopy.ListOfOriginalFiles;
            this.mediaDialogData.canUpload = this.originalDataCopy.canUpload;
            this.mediaDialogData.originalFile = this.originalDataCopy.originalFile;
            this.mediaDialogData.FileType = this.originalDataCopy.FileType;
            this.mediaDialogData.ListzipFiles = this.originalDataCopy.ListzipFiles;
            this.mediaDialogData.ListOfAudioFiles1 = this.originalDataCopy.ListOfAudioFiles1;
            this.mediaDialogData.IsMergeAudios = this.originalDataCopy.IsMergeAudios;
            this.mediaDialogData.ListOfMergeAudioFiles = this.originalDataCopy.ListOfMergeAudioFiles;
            this.mediaDialogData.MergeAudioFileNameList = this.originalDataCopy.MergeAudioFileNameList;
            if (this.ref === "record" && action == "close" && this.RecordingTimer) {
                if (this.isRecording) {
                    this.sendNotification("Recording is in progress. Please stop the recording before clicking the Close button.", "error");
                }
                else {
                    this.mode = "RemoveFileForDialogClose";
                    await this.sweetalert(null, action);
                }

            }
            else {
                if (this.isRecording) {
                    this.sendNotification("Recording is in progress. Please stop the recording before clicking the Cancel button.", "error");
                }
                else {
                    this.spinner.show();
                    if(!this.canUpload){
                        this.ListOfAudioFiles =[]
                    }
                    this.CloseMediaDialogData();
                    var openRecordTab: any = await this.fileaccess.resumePendingUploads();
                    const parsedResponse =
                        typeof openRecordTab === "string"
                            ? JSON.parse(openRecordTab)
                            : openRecordTab;

                    console.log("parsedResponse", parsedResponse);
                    if (parsedResponse.success) {
                        const recording = parsedResponse.response?.data?.recording;

                        await Swal.fire({
                            html: `<p style="text-align:left;">
                      ${recording?.filePath?.split('/').pop()}
                      created on ${new Date(this.datePipe.transform(recording?.createdTime, 'yyyy-MM-dd HH:mm:ss'))}
                      uploaded successfully.
                    </p>`,
                            icon: 'success',
                            confirmButtonText: 'OK'
                        }).then(res => {
                            if (res.isConfirmed) {
                                this.spinner.hide();
                            }
                        });
                    }

                }

            }
        }

        else if (this.ref === "estimate") {
            this.dialogRef.close(this.estimateDialogData);
        }
        else if (this.ref === "addNotes") {
            this.dialogRef.close(this.notesDialogData);
        }
        else {
            this.dialogRef.close("clear");
        }
    }

    isSaveEnabled(): boolean {
        if (this.ref === "addNotes") {
            return true;
        }
        else if (this.ref === "attachDocs") {
            return true;
        }
        else if (this.ref === "media" || this.ref === "record") {
            return this.canUpload;
        }
        return false;
    }

    SaveDetails() {
        if (this.ref === "addNotes") {
            this.notesDialogData.Notes = this.notesComponent.val();
            if (this.showCustomerNotes) {
                this.notesDialogData.custNotes = this.customerNotesComponent.val();
            }
            else {
                this.notesDialogData.custNotes = null;
            }
            console.log("NotesdialogData", this.notesDialogData);
            this.dialogRef.close(this.notesDialogData);
        }
        else if (this.ref === "attachDocs") {
            this.attachmentsDialogData.ListOfAttachments = this.ListOfAttachments;
            this.attachmentsDialogData.ListOfAttachmentFiles = this.ListOfAttachmentFiles;
            console.log("AttachmentsDialogData", this.attachmentsDialogData);
            this.dialogRef.close(this.attachmentsDialogData);
        }
        else if (this.ref === "media" || this.ref === "record") {
            this.mediaDialogData.ListOfAudioFiles = this.ListOfAudioFiles;
            this.mediaDialogData.ListOfOriginalFiles = this.ListOfOriginalFiles;
            this.mediaDialogData.canUpload = this.canUpload;
            this.mediaDialogData.originalFile = this.originalFile;
            this.mediaDialogData.FileType = (this.ref === "media") ? this.FileType : "mp3";
            this.mediaDialogData.ListzipFiles = ListzipFiles;
            this.mediaDialogData.ListOfAudioFiles1 = this.ListOfAudioFiles1;
            this.mediaDialogData.IsMergeAudios = this.IsMergeAudios;
            this.mediaDialogData.ListOfMergeAudioFiles = this.ListOfMergeAudioFiles;
            this.mediaDialogData.MergeAudioFileNameList = this.MergeAudioFileNameList;
            this.mediaDialogData.isRecording = (this.ref === "record") ? true : false;
            this.mediaDialogData.recordingSessionId = this.sessionId;
            console.log("MediadialogData", this.mediaDialogData);
            this.dialogRef.close(this.mediaDialogData);
        }
    }

    TranscriptionTypeClick(value) {
        this.transcriptionType = value;
        if ((this.transcriptionType == 1 && this.sepTrans.checked == false) || (this.transcriptionType == 2 && this.oneTrans.checked == false) || (this.transcriptionType == 3)) {
            this.mode = "ChangeTranscriptionType";
            this.sweetalert(null, null);
        }
    }

    TranscriptionTypeChange() {
        this.remove()
        if (this.transcriptionType == 1) {
            //Individual Transcripts
            this.IsMergeAudios = false;
            this.IsMergeAudiosGlobal = false;
            this.canUpload = this.isfutureorder ? true : false;
        }
        else if (this.transcriptionType == 2) {
            //one Transcript
            this.IsMergeAudios = true;
            this.IsMergeAudiosGlobal = true;
        }
        this.transcriptionType = undefined;
    }
    remove() {
        this.file = null;
        this.originalFile = null;
        //this.canUpload = false;
        ///Multiple Audio files
        this.ListOfNames = "";
        this.ListOfOriginalFiles = [];
        ListzipFiles = [];
        this.ListOfAudioFiles = [];
        this.ListOfZipFiles = [];
        this.ListOfMergeAudioFiles = [];
        this.MergeAudioFileNameList = [];
        this.MergeAudioFilescount = 0;
        this.CompleteAudioFilescount = 0;
        this.ListOfAttachments = [];
        this.ListOfAudioFiles1 = [];
        this.MergeAudioFormat = "";
        this.ListofJobCreateDto = [];
        this.ListofJobCreateInputDto = [];
        this.ListOfAttachmentFiles = [];
        this.ListOfMergeAudioFiles = [];
        this.ListOfAttachments1Global = [];
    }
    drop(event: CdkDragDrop<FileToUpload[]>) {
        if (event.previousContainer === event.container) {
            // Reorder within the same list
            moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
        } else {
            // Move from one list to another
            transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex
            );
        }
        if (this.IsMergeAudios) {
            const isProgressive = this.mediaDialogData?.isUploadProgressively === true;
            // Step 0: Clear all relevant lists
            this.ListOfAudioFiles1 = [];
            this.ListOfAudioFiles = [];
            this.ListOfMergeAudioFiles = [];
            this.ListOfOriginalFiles = [];
            this.MergeAudioFileNameList = [];
            // Step 1: Process dropped files
            event.container.data.forEach((file: File | FileToUpload, index: number) => {
                const originalName = (file as any).FileName || (file as any).fileName || (file as any).name;
                const nameParts = originalName.split('-');
                const actualFileName = nameParts.length > 1 ? nameParts.slice(1).join('-') : originalName;
                // ✅ Filename depends on progressive flag
                const updatedFileName = isProgressive ? actualFileName : `${index + 1}-${actualFileName}`;
                const fileType = (file as any).fileType || (file as any).type;
                const fileSize = (file as any).fileSize || (file as any).size;
                const lastModifiedTime = (file as any).lastModifiedTime || (file as any).lastModified;
                const lastModifiedDate = (file as any).lastModifiedDate || new Date(lastModifiedTime);
                // Step 2: Create FileToUpload object
                const fileToUpload: FileToUpload = {
                    fileName: updatedFileName,
                    FileName: updatedFileName,
                    fileType: fileType === 'audio/webm' ? 'audio/mp3' : fileType,
                    fileSize,
                    lastModifiedTime,
                    lastModifiedDate,
                    fileAsBase64: ""
                };
                this.ListOfAudioFiles1.push(fileToUpload);
                this.MergeAudioFileNameList.push(updatedFileName);
                // Step 3: Convert to actual File
                const blobData = file instanceof File ? file : new Blob([], { type: fileToUpload.fileType });
                const realFile = new File([blobData], updatedFileName, {
                    type: fileToUpload.fileType,
                    lastModified: lastModifiedTime
                });
                (realFile as any).FileName = updatedFileName;
                this.ListOfAudioFiles.push(realFile);
                this.ListOfOriginalFiles.push(realFile);
            });

            // Step 4: Copy to merge list
            this.ListOfMergeAudioFiles = [...this.ListOfAudioFiles];

            // Step 5: Remove FileName field from FileToUpload for display
            this.ListOfAudioFiles1 = this.ListOfAudioFiles1.map(({ FileName, ...rest }) => rest);

            // Step 6: Set flag and original file
            this.mediaDialogData.isUploadProgressively = isProgressive;
            if (this.ListOfOriginalFiles.length > 0) {
                this.originalFile = this.ListOfOriginalFiles[this.ListOfOriginalFiles.length - 1];
            }
        }
    }

    private readAndUploadAudioFile(theFile: any) {
        // Removing special chars from filename
        var filenamewithoutextension = theFile.name.substr(theFile.name.lastIndexOf('\\') + 1);
        filenamewithoutextension = filenamewithoutextension.substr(0, filenamewithoutextension.lastIndexOf('.'));
        let noWhiteSpace = filenamewithoutextension.replace(/ /g, "_");
        var desiredFilename = noWhiteSpace.replace(/[^\w\s]/gi, '')
        let Fileextension = theFile.name.split(/[.;+_]/).pop().toLowerCase();
        var desiredFileNameWithExtension = desiredFilename + "." + Fileextension;
        var AudioFilecounter = this.ListOfOriginalFiles.length;
        this.Audiofile = new FileToUpload();
        if (this.mediaDialogData.isUploadProgressively) {
            this.Audiofile.fileName = desiredFileNameWithExtension;
            theFile.FileName = desiredFileNameWithExtension;
        }
        else {
            this.Audiofile.fileName = AudioFilecounter + "-" + desiredFileNameWithExtension;
            theFile.FileName = AudioFilecounter + "-" + desiredFileNameWithExtension;
        }
        this.Audiofile.fileSize = theFile.size;
        this.Audiofile.fileType = theFile.type;
        if (theFile.type == "audio/webm") {
            this.Audiofile.fileType = "audio/mp3"
        }
        this.Audiofile.lastModifiedTime = theFile.lastModified;
        this.Audiofile.lastModifiedDate = theFile.lastModifiedDate;

        this.ListOfAudioFiles1.push(this.Audiofile);
        this.ListOfMergeAudioFiles.push(theFile);
        this.MergeAudioFileNameList.push(theFile.FileName);
        this.spinner.hide();
    }
    private readAndUploadAttachmentFile(theFile: any) {
        // Removing special chars from filename
        var filenamewithoutextension = theFile.name.substr(theFile.name.lastIndexOf('\\') + 1);
        filenamewithoutextension = filenamewithoutextension.substr(0, filenamewithoutextension.lastIndexOf('.'));
        let noWhiteSpace = filenamewithoutextension.replace(/ /g, "_");
        var desiredFilename = noWhiteSpace.replace(/[^\w\s]/gi, '')
        let Fileextension = theFile.name.split(/[.;+_]/).pop().toLowerCase();
        var desiredFileNameWithExtension = desiredFilename + "." + Fileextension;
        this.Attachmentfile = new FileToUpload();
        this.Attachmentfile.fileName = desiredFileNameWithExtension;
        this.Attachmentfile.fileSize = theFile.size;
        this.Attachmentfile.fileType = theFile.type;
        this.Attachmentfile.lastModifiedTime = theFile.lastModified;
        this.Attachmentfile.lastModifiedDate = theFile.lastModifiedDate;
        this.ListOfAttachments.push(this.Attachmentfile);
        console.log("readAndUploadAttachmentFile ListOfAttachments", this.ListOfAttachments);
        console.log("readAndUploadAttachmentFile ListOfAttachmentFiles", this.ListOfAttachmentFiles);
        this.spinner.hide();
    }
    async loadDeparmentValues() {
        this.departmentOptions = [];
        var departmentListDetails = await this.backendService.getDepartments().toPromise();
        let departmentList = this.backendService.getJSONResponse(departmentListDetails['data'].departmentList);
        for (let department of departmentList) {
            //TODO: FD
            let data = {
                'id': department.id,
                'name': department.name +
                    ' (' + department.organizationname + ')',
                'deptExtId': department.deptExtId,
                'isFutureOrder': department.isFutureOrder,
                'isForeignLanguage': department.isForeignLanguage,
                'isForeignLanguageFirstDraft': department.isForeignLanguageFirstDraft,
                'isSensitive': department.isSensitive,
                'isCertification': department.isCertification,
                'isNotarization': department.isNotarization,
                'defaultForeignLanguageService': department.defaultForeignLanguageService,
                'defaultSourceForeignLanguage': department.defaultSourceForeignLanguage,
                'allowMultipleJobs': department.allowMultipleJobs,
                'isUploadProgressively': department.isUploadProgressively,
                'estimationMessage': department.estimationMessage
            }
            this.departmentOptions.push(data);
        }
        this.deptfilteredOptions = this.departmentControl.valueChanges
            .pipe(
                startWith(''),
                map(value => typeof value === 'string' ? value : value['name']),
                map(name => name ? this.departmentfilter(name) : this.departmentOptions.slice()),
            );
        if (this.departmentOptions.length == 1) {
            let selectedDept = this.departmentOptions.find(dept => dept.id === this.selectedDepartmentId);
            this.isForeignLanguage = selectedDept.isForeignLanguage;
            this.selectedIndex = this.isForeignLanguage == true ? 1 : 0;
            this.DisplayEstimationMessage = selectedDept.estimationMessage;
            this.deptName = selectedDept.name;
            this.deptExtId = selectedDept.deptExtId
            this.departmentControl.setValue(selectedDept);
            this.departmentControl.disable({ onlySelf: true });
            this.selectedDepartmentId = selectedDept.id;
            this.departmentSingleOptionChangeEvent(selectedDept);
        }
    }
    departmentSingleOptionChangeEvent(event: any): void {
        if (event.id) {
            this.selectedDepartmentId = event.id;
            this.EstimateloadJobTypeValues(event.id);
            this.EstimatejobtypeControl.enable({ onlySelf: true });
        }
    };
    private departmentfilter(name: any): dropdownmodel[] {
        const filterValue = name.toLowerCase();
        return this.departmentOptions.filter(option => option.name.toLowerCase().indexOf(filterValue) >= 0);
    }
    departmentChangeEvent(event: any): void {
        this.isfutureorder = false;
        this.spinner.show();
        this.selectedDepartmentId = (this.showEstimateAmount) ? event.value.id : event.option.value.id;
        this.isForeignLanguage = (this.showEstimateAmount) ? event.value.isForeignLanguage : event.option.value.isForeignLanguage;
        this.deptName = (this.showEstimateAmount) ? event.value.name : event.option.value.name;
        this.deptExtId = (this.showEstimateAmount) ? event.value.deptExtId : event.option.value.deptExtId
        this.selectedIndex = this.isForeignLanguage == true ? 1 : 0;
        this.DisplayEstimationMessage = (this.showEstimateAmount) ? event.value.estimationMessage : event.option.value.estimationMessage;
        this.showEstimateAmount = (this.showEstimateAmount) ? true : false;
        this.numberOfMins = (this.showEstimateAmount) ? this.numberOfMins : null;
        this.receiptEmail = (this.showEstimateAmount) ? this.receiptEmail : null;
        if (!this.showEstimateAmount) {
            this.EstimatejobtypeControl.setValue('');
            this.EstimateloadJobTypeValues((this.showEstimateAmount) ? event.value.id : event.option.value.id);
            this.EstimatejobtypeControl.enable({ onlySelf: true });
        }
        this.spinner.hide();
    };
    departmentChange() {
        this.selectedDepartmentId = '';
        this.selectedJobTypeExtId = '';
        this.selectedJobTypeDisplayName = '';
        this.EstimatejobtypeControl.setValue('');
        this.numberOfMins = null;
        this.receiptEmail = null;
    }

    async startRecording() {
        try {
            // Reset timers and flags
            this.hr = '00';
            this.min = '00';
            this.sec = '00';
            clearInterval(this.interval);

            this.spinner.show();
            //this.showRecordAudio = true;
            this.isRecording = true;
            localStorage.setItem('IsRecording','true');
            this.isStopping = false;
            this.chunkIndex = 0;
            this.currentSizeMB = 0;
            this.partNumber = 1;
            this.PartETags = [];

            // Get microphone access
            this.stream = await navigator.mediaDevices.getUserMedia({ audio: true });

            // Generate session ID
            this.sessionId = crypto.randomUUID();
            console.log("Session ID:", this.sessionId);
            await this.wakeLockService.requestWakeLock();
            // Start backend recording session
             this.backendService.AddRecording(this.sessionId).subscribe(
                (response: any) => { 
                     if (response.success) {
                        
                         // Pause the idle timer when recording starts
                         this.idle.stop();  
                         //this.idle.setTimeout(0);  // Disable timeout while recording
                         this.spinner.hide();
                         console.log("AddRecording response:", response);

                         this.uploadSession = {
                             uploadId: response.data.uploadId,
                             fileKey: response.data.fileKey
                         };

                         console.log('Multipart session started', this.uploadSession);

                         // Start timers
                         this.RecordingTime();
                         this.RecordingTimer = true;
                         this.PauseRecordingTimer = false;

                         // Setup MediaRecorder
                         this.mediaRecorder = new MediaRecorder(this.stream, { mimeType: 'audio/webm' });
                         this.mediaRecorder.ondataavailable = async (event: BlobEvent) => {
                             if (event.data && event.data.size > 0) {
                                 // Save chunk to IndexedDB or upload
                                 await this.saveChunkToIndexedDB(event.data, this.chunkIndex, false);
                                 console.log(`Saved chunk ${this.chunkIndex}`);
                                 this.chunkIndex++;
                             }
                         };

                         this.mediaRecorder.start(10000); // 10-second chunks
                         console.log("Recording started!");
                     } else {
                         this.sendNotification(response.Message, "error");
                     }
                },
                (error) => {
                    console.error('AddRecording', error);
                }
            );


        } catch (err) {
            console.error('Error accessing microphone:', err);
        }
    }

    // ===== 🔢 PCM Conversion =====
    floatTo16BitPCM(float32Array: Float32Array): Int16Array {
        const buffer = new Int16Array(float32Array.length);
        for (let i = 0; i < float32Array.length; i++) {
            const s = Math.max(-1, Math.min(1, float32Array[i]));
            buffer[i] = s < 0 ? s * 0x8000 : s * 0x7FFF;
        }
        return buffer;
    }
    async stopRecordingAndUpload() {
        if (this.isStopping) return;
        this.isStopping = true;

        console.log("Stopping recording...");
        this.isRecording = false;

        try {
            this.wakeLockService.releaseWakeLock();  // <-- ALLOW SLEEP AGAIN
            this.idle.watch();  
            localStorage.setItem('IsRecording','false');
            if (this.mediaRecorder && this.mediaRecorder.state !== "inactive") {
                await new Promise<void>((resolve) => {
                    this.mediaRecorder.onstop = () => resolve();
                    this.mediaRecorder.stop();
                });
            }

            // Stop microphone tracks
            if (this.stream) {
                this.stream.getTracks().forEach(track => track.stop());
            }

            // Wait for any ongoing upload to finish
            while (this.isUploading) {
                console.log("Waiting for current upload to finish...");
                await new Promise(r => setTimeout(r, 300));
            }

            const db = await this.dbPromise;
            const remainingChunks = await db.getAll('chunks');

            if (remainingChunks.length > 0) {
                console.log(`Finalizing remaining ${remainingChunks.length} chunks`);
                await this.uploadChunkBuffer(remainingChunks); // use updated MediaRecorder version
            }

            await this.completeMultipartUpload();
            console.log("Multipart upload completed");

            await db.clear('chunks');
            console.log("IndexedDB cleaned");

        } catch (err) {
            console.error("Error during stopRecordingWithMediaRecorder:", err);
        } finally {
            this.isStopping = false;
            this.spinner.hide();
            console.log("Recording stopped");
        }
    }

    // =====  STOP RECORDING =====
    async stopRecording() {
        //clearInterval(this.interval);
        //this.pauseButtonShow = false;
        //this.resumeRecordShow = false;
        this.mode = "StopRecording";
        this.sweetalert(null, null);
    }
    // ===== ⏸️ PAUSE RECORDING (MediaRecorder) =====
    async pauseRecording() {
        if (!this.isRecording || !this.pauseButtonShow) return;

        this.pauseButtonShow = false;
        this.resumeRecordShow = true;
        this.canUpload = false;
        clearInterval(this.interval);

        console.log("⏸️ Pausing recording...");

        if (this.mediaRecorder && this.mediaRecorder.state === 'recording') {
            this.mediaRecorder.pause(); // built-in pause
            this.isRecording = false;
            console.log(" Recording paused with MediaRecorder");
        }
    }


    private async saveChunkToIndexedDB(chunk: Blob, chunkIndex: number, isFinalChunk: boolean) {
        const db = await this.dbPromise;
        const db2 = await this.dbPromise2;
        const id = `${this.sessionId}-${chunkIndex}`;

        // Save blob to IndexedDB
        await db.put('chunks', {
            id,
            data: chunk,
            uploaded: false,
            sessionId: this.sessionId,
            uploadId: this.uploadSession?.uploadId,
            fileKey: this.uploadSession?.fileKey
        });

        // Add to in-memory buffer
        this.memoryBuffer.push({ id, data: chunk });

        // Compute total size of buffered blobs
        const totalSize = this.memoryBuffer.reduce((sum, c) => sum + c.data.size, 0);

        console.log("totalSize ::: ", totalSize);
        // Upload only when total buffered size >= 5 MB and not currently uploading
        if (totalSize >= this.CHUNK_SIZE && !this.isUploading) {
            await this.uploadBufferedChunks();
        }
    }

    private async uploadBufferedChunks() {
        if (this.memoryBuffer.length === 0) return;
        this.isUploading = true;

        // Combine all buffered blobs into a single blob
        const blobsArray: Blob[] = [];
        const db = await this.dbPromise;
        const db2 = await this.dbPromise2;
        
        
        // Collect blobs and keep their IDs for deletion
        const chunkIds: string[] = [];
        for (const chunkRecord of this.memoryBuffer) {
            blobsArray.push(chunkRecord.data);
            chunkIds.push(chunkRecord.id);
        }

        const combinedBlob = new Blob(blobsArray, { type: 'audio/webm' }); // or 'audio/mpeg'

        // Clear memory buffer early to accept new chunks
        this.memoryBuffer = [];

        try {
            const body = {
                uploadId: this.uploadSession.uploadId,
                fileKey: this.uploadSession.fileKey,
                partNumber: this.partNumber,
            };

            await this.delay(10000);
            const presignedUrl: any = await this.backendService.GetUploadUrl(body).toPromise();
            var result = JSON.parse(presignedUrl);
            console.log("result::", result);

            if (JSON.parse(presignedUrl).success) {
                const res = await fetch(JSON.parse(presignedUrl).data!, {
                    method: 'PUT',
                    body: combinedBlob,
                    headers: { 'Content-Type': 'audio/mpeg' },
                });

                if (res.ok) {
                    const eTag = res.headers.get('ETag') ?? '';
                    this.PartETags.push({ partNumber: this.partNumber, eTag });
                    console.log(`Uploaded part #${this.partNumber} (${(combinedBlob.size / (1024 * 1024)).toFixed(2)} MB)`);
                                    // ---------- Save to IndexedDB ----------
                    const txUP = db2.transaction('uploadedParts', 'readwrite');
                    const storeUP = txUP.objectStore('uploadedParts');

                    let session = await storeUP.get(this.sessionId);

                    if (!session) {
                        session = {
                            id: this.sessionId,
                            uploadId: this.uploadSession.uploadId,
                            fileKey: this.uploadSession.fileKey,
                            partETags: []
                        };
                    }

                    // Remove old entry for retry
                    session.partETags = session.partETags.filter(p => p.PartNumber !== this.partNumber);

                    // Add new ETag
                    session.partETags.push({ PartNumber: this.partNumber, ETag: eTag });

                    // Keep sorted
                    session.partETags.sort((a, b) => a.PartNumber - b.PartNumber);

                    // Save updated session
                    await storeUP.put(session);
                    await txUP.done;

                    console.log('Saved uploaded part to IndexedDB:', session);

                    // Increment part number
                    this.partNumber++;

                    // ---------- Delete uploaded chunks ----------
                    const tx = db.transaction('chunks', 'readwrite');
                    const store = tx.objectStore('chunks');
                    for (const id of chunkIds) await store.delete(id);
                    await tx.done;
                } else {
                    console.error('Upload failed for combined blob');
                    // Retry later by restoring memory buffer
                    this.memoryBuffer.push(...blobsArray.map((b, i) => ({ id: chunkIds[i], data: b })));
                }
            }
        } catch (err) {
            console.error('⚠️ Error uploading combined blob:', err);
            // Retry later by restoring memory buffer
            this.memoryBuffer.push(...blobsArray.map((b, i) => ({ id: chunkIds[i], data: b })));
        } finally {
            this.isUploading = false;
        }
    }




    // ===== 🧩 UPLOAD 5MB BUFFER TO S3 =====
    private async uploadChunkBuffer(chunks: any[]) {
        const db = await this.dbPromise;
         const db2 = await this.dbPromise2;
        const blobsArray: Blob[] = [];
        
         chunks.sort((a, b) => {
            const indexA = Number(a.id.split('-').pop());
            const indexB = Number(b.id.split('-').pop());
            return indexA - indexB;
          });

        for (const c of chunks) {
            blobsArray.push(c.data); // collect blobs in order
        }

        const blob = new Blob(blobsArray, { type: 'audio/webm' }); // or 'audio/mpeg'
        console.log('Combined Blob size:', blob.size);

        //this.downloadBlob(blob, 'recording.wav');
        const body = {
            uploadId: this.uploadSession.uploadId,
            fileKey: this.uploadSession.fileKey,
            partNumber: this.partNumber,
        };

        try {
            const presignedUrl: any = await this.backendService.GetUploadUrl(body).toPromise();
            var result = JSON.parse(presignedUrl);
            console.log("result::", result);
            if (JSON.parse(presignedUrl).success) {
                const res = await fetch(JSON.parse(presignedUrl).data!, {
                    method: 'PUT',
                    body: blob,
                    headers: { 'Content-Type': 'audio/mpeg' },
                });

                if (res.ok) {
                    const eTag = res.headers.get('ETag') ?? '';
                    this.PartETags.push({ partNumber: this.partNumber, eTag });
                // ---------- Save to IndexedDB ----------
                    const txUP = db2.transaction('uploadedParts', 'readwrite');
                    const storeUP = txUP.objectStore('uploadedParts');

                    let session = await storeUP.get(this.sessionId);

                    if (!session) {
                        session = {
                            id: this.sessionId,
                            uploadId: this.uploadSession.uploadId,
                            fileKey: this.uploadSession.fileKey,
                            partETags: []
                        };
                    }

                    // Remove old entry for retry
                    session.partETags = session.partETags.filter(p => p.PartNumber !== this.partNumber);

                    // Add new ETag
                    session.partETags.push({ PartNumber: this.partNumber, ETag: eTag });

                    // Keep sorted
                    session.partETags.sort((a, b) => a.PartNumber - b.PartNumber);

                    // Save updated session
                    await storeUP.put(session);
                    await txUP.done;
                    console.log('Saved uploaded part to IndexedDB:', session);

                    // Increment part number
                    this.partNumber++;
                    // Delete uploaded chunks
                    const tx = db.transaction('chunks', 'readwrite');
                    const store = tx.objectStore('chunks');
                    for (const c of chunks) await store.delete(c.id);
                    await tx.done;

                    console.log(`✅ Uploaded part #${this.partNumber - 1} (${(blob.size / (1024 * 1024)).toFixed(2)} MB)`);
                } else {
                    console.error("❌ Upload failed for buffer");
                }
            }

        } catch (err) {
            console.error("⚠️ Error uploading buffer:", err);
        }
    }

    // ===== ✅ COMPLETE MULTIPART UPLOAD =====
    private async completeMultipartUpload() {
        if (!this.uploadSession?.uploadId || !this.uploadSession?.fileKey) {
            console.warn('⚠️ No active upload session found.');
            return;
        }

        const body = {
            uploadId: this.uploadSession.uploadId,
            Key: this.uploadSession.fileKey,
            partETags: this.PartETags,
            SessionId: this.sessionId
        };
        console.log("complete body:::", body);
        try {
            const response: any = await this.backendService.CompleteMultipart(body).toPromise();

            // ✅ Parse the response first (since it's a JSON string)
            const parsedResponse = typeof response === 'string' ? JSON.parse(response) : response;

            // ✅ Then assign GlobalOutput as an object
            this.GlobalOutput = parsedResponse || {};
            const filePath = parsedResponse?.data.recording?.filePath;
            // this.IsAudioPlay = true;
            this.RecordingTimer = false;
           // this.showRecordAudio = false;
            this.startRecordShow = false;
            this.pauseButtonShow = false;
            this.stopButtonShow = false;
            this.resumeRecordShow = false;
            this.showAudioFileList = true;
            this.showPlayDetails = true;
            this.originalRecordingURL = parsedResponse?.data.originalURL;
            this.convertedRecordingURL = parsedResponse?.data.convertedURL;
            this.sessionId = parsedResponse?.data.recording?.sessionId;
            this.recordingFileName = parsedResponse?.data.recording?.filePath.split('/').pop()!;

            if (filePath) {
                const fileName = filePath.substring(filePath.lastIndexOf('/') + 1);
                this.GlobalOutput['name'] = fileName.substring(0, fileName.lastIndexOf('.')) + '.mp3'; // ✅ Safe now, since it's an object
                this.GlobalOutput['isRecording'] = true;
            }

            const db2 = await this.dbPromise2;

            const tx = db2.transaction('uploadedParts', 'readwrite');
            const store = tx.objectStore('uploadedParts');
            const result = await store.get(this.sessionId);
            if(result)
            {
            await store.delete(this.sessionId);   
            console.log("Session deleted from indexedDB:", this.sessionId);
            }
            await tx.done;
            console.log("output::::", this.GlobalOutput);

            await this.processAudioFiles(this.GlobalOutput);
            this.originalFile = this.GlobalOutput;
            this.canUpload = true;
            this.chunkIndex = 0;
            this.sendNotification('Recording is in conversion...', 'success');
            console.log('✅ Multipart upload completed:', response);

        } catch (error) {
            console.error('❌ Failed to complete multipart upload:', error);
        }
    }
    async resumeRecording() {
        if (this.pauseButtonShow) return;
        this.DisableStopRecording = false;
        this.canUpload = false
        if (this.ListOfOriginalFiles.length > 0 && this.originalFile) {
            this.spinner.show();
            //this.isStopping = false;
            this.PrevioussessionId = this.sessionId;
            console.log("▶️ Appending new audio to existing recording...");
            this.IsAudioPlay = false;
            this.isRecording = true;
            this.showPlayDetails = false;
            this.RecordingTimer = true;
            this.showAudioFileList = false;
            this.sessionId = crypto.randomUUID();

            // 1️⃣ Start a new multipart upload
            const response: any = await this.backendService.AddRecording(this.sessionId).toPromise();
            if (!response?.success) {
                console.error("❌ Failed to start new multipart session");
                return;
            }
            this.uploadSession = {
                uploadId: response.data.uploadId,
                fileKey: response.data.fileKey
            };
            this.PartETags = [];
            this.partNumber = 1;
            console.log("🪣 New multipart session started:", this.uploadSession);

            // 2️⃣ Preload existing recording, upload full 5MB chunks, store leftover in IndexedDB
            await this.preloadExistingRecordingToIndexedDBAndUpload(this.originalRecordingURL);
            await this.backendService.UpdateRecording(this.PrevioussessionId).subscribe(
                (response: any) => {
                    // if (response.success) {
                    //         this.sessionId = response.data.recording.sessionId;
                    //     }
                },
                (error) => {
                    console.error('UpdateRecording', error);
                }
            );
            this.ListOfOriginalFiles = this.ListOfOriginalFiles.filter(
                (file: any) => file?.data?.recording?.sessionId !== this.PrevioussessionId
            );

            this.ListOfOriginalFiles = this.ListOfOriginalFiles.filter(
                (file: any) =>
                    !file?.isRecording ||
                    file?.data?.recording?.sessionId !== this.PrevioussessionId
            );

            this.ListOfAudioFiles = this.ListOfAudioFiles.filter(
                (file: any) =>
                    !file?.isRecording ||
                    file?.data?.recording?.sessionId !== this.PrevioussessionId
            );

            if (!this.stream) {
                this.stream = await navigator.mediaDevices.getUserMedia({ audio: true });
            }
            this.mediaRecorder = new MediaRecorder(this.stream, { mimeType: 'audio/webm' });

            this.mediaRecorder.ondataavailable = async (event: BlobEvent) => {
                if (event.data && event.data.size > 0) {
                    await this.saveChunkToIndexedDB(event.data, this.chunkIndex, false);
                    console.log(`💾 Saved MediaRecorder chunk #${this.chunkIndex}`);
                    this.chunkIndex++;
                }
            };

            this.mediaRecorder.start(10000); // collect data in 1-second chunks

            this.pauseButtonShow = true;
            this.resumeRecordShow = false;
            this.RecordingTime();
            this.spinner.hide();
            console.log("🎧 Recording resumed and appending...");
        }
        else {
            // 🔁 Normal resume (no previous recording)
            console.log("▶️ Resuming normal recording...");
            this.RecordingTime();
            this.pauseButtonShow = true;
            this.isRecording = true;
            this.resumeRecordShow = false;

            if (!this.stream) {
                this.stream = await navigator.mediaDevices.getUserMedia({ audio: true });
            }

            this.mediaRecorder = new MediaRecorder(this.stream, { mimeType: 'audio/webm' });

            this.mediaRecorder.ondataavailable = async (event: BlobEvent) => {
                if (event.data && event.data.size > 0) {
                    await this.saveChunkToIndexedDB(event.data, this.chunkIndex, false);
                    console.log(`💾 Saved MediaRecorder chunk #${this.chunkIndex}`);
                    this.chunkIndex++;
                }
            };

            this.mediaRecorder.start(10000); // collect data in 1-second chunks
            console.log("🎧 Recording resumed (new session)");
        }
    }

    async preloadExistingRecordingToIndexedDBAndUpload(url: string) {
        const response = await fetch(url);
        const reader = response.body.getReader();
        const db = await this.dbPromise;
        const db2 = await this.dbPromise2;
        //const CHUNK_SIZE = 5 * 1024 * 1024; // 5 MB
        let buffer = new Uint8Array();

        while (true) {
            const { done, value } = await reader.read();
            if (done) break;

            const newBuffer = new Uint8Array(buffer.length + value.length);
            newBuffer.set(buffer);
            newBuffer.set(value, buffer.length);
            buffer = newBuffer;

            // Upload 5MB chunks
            while (buffer.length >= this.CHUNK_SIZE) {
                const chunkToUpload = buffer.slice(0, this.CHUNK_SIZE);
                buffer = buffer.slice(this.CHUNK_SIZE);

                const body = {
                    uploadId: this.uploadSession.uploadId,
                    fileKey: this.uploadSession.fileKey,
                    partNumber: this.partNumber
                };

                try {
                    const presignedUrlResp: any = await this.backendService.GetUploadUrl(body).toPromise();
                    const presignedUrl = typeof presignedUrlResp === 'string' ? JSON.parse(presignedUrlResp) : presignedUrlResp;

                    const res = await fetch(presignedUrl.data, {
                        method: 'PUT',
                        body: new Blob([chunkToUpload]),
                        headers: { 'Content-Type': 'audio/mpeg' }
                    });

                    if (res.ok) {
                        const eTag = res.headers.get('ETag') ?? '';
                        this.PartETags.push({ partNumber: this.partNumber, eTag });
                        console.log(`✅ Uploaded existing part #${this.partNumber} (${(chunkToUpload.length / 1024 / 1024).toFixed(2)} MB)`);
                         // ---------- Save to IndexedDB ----------
                    const txUP = db2.transaction('uploadedParts', 'readwrite');
                    const storeUP = txUP.objectStore('uploadedParts');
 
                    let session = await storeUP.get(this.sessionId);
 
                    if (!session) {
                        session = {
                            id: this.sessionId,
                            uploadId: this.uploadSession.uploadId,
                            fileKey: this.uploadSession.fileKey,
                            partETags: []
                        };
                    }
 
                    // Remove old entry for retry
                    session.partETags = session.partETags.filter(p => p.PartNumber !== this.partNumber);
 
                    // Add new ETag
                    session.partETags.push({ PartNumber: this.partNumber, ETag: eTag });
 
                    // Keep sorted
                    session.partETags.sort((a, b) => a.PartNumber - b.PartNumber);
 
                    // Save updated session
                    await storeUP.put(session);
                    await txUP.done;
 
                    console.log('Saved uploaded part to IndexedDB:', session);
                        this.partNumber++;
                    } else {
                        console.error('❌ Failed uploading existing chunk');
                    }
                } catch (err) {
                    console.error('⚠️ Error uploading existing chunk:', err);
                }

                this.chunkIndex++;
            }
        }

        // Leftover < 5MB → keep in IndexedDB
        if (buffer.length > 0) {
            const id = `${this.sessionId}-${this.chunkIndex}`;
            await db.put('chunks', { id, data: new Blob([buffer]), uploaded: false, sessionId: this.sessionId, uploadId: this.uploadSession?.uploadId, fileKey: this.uploadSession?.fileKey });
            this.memoryBuffer.push({ id, data: new Blob([buffer]) });
            console.log(`💾 Stored leftover existing chunk ${this.chunkIndex} (${(buffer.length / 1024 / 1024).toFixed(2)} MB)`);
            this.chunkIndex++;
        }

        console.log(`✅ Uploaded existing recording parts and preloaded leftover chunk.`);
    }

    handleOffline() {
        this.spinner.show();
        this.pauseRecording();
        this.audioRecorderService.pause();
        this.pauseButtonShow = false;
        this.resumeRecordShow = true;
        clearInterval(this.interval);
    }
    async handleOnline() {
        //await this.fileaccess.resumePendingUploads();
        clearInterval(this.interval);
        this.spinner.hide();
    }
    async downloadImageClick() {
        this.audioDownload();
    }
    async audioDownload() {
        this.spinner.show();
        let url = this.convertedRecordingURL;
        let filename = this.recordingFileName.substring(0, this.recordingFileName.lastIndexOf('.')) + '.mp3' ;
        this.fileDownloadLoop(url, filename, true);
    }
    async fileDownloadLoop(url, fileName, IsProgress) {
        this.spinner.show();
        (await this.fileaccess.downloadWithProgress(url, fileName, IsProgress)).subscribe({
            next: (event: any) => {
                if (event.type === 'progress') {
                    this.progress = event.value;
                } else if (event.type === 'response') {
                    this.spinner.hide();
                    this.progress = 0
                    this.sendNotification(fileName + ' - File Downloaded successfully.', 'success');
                }
            },
            error: (err) => {
                this.spinner.hide();
                console.log(err);
                this.sendNotification('Downloded failed.', 'error');
            }
        });
    }
   async getDurationByUrl(parsedResponse: any) {
        this.hr = '00';
        this.min = '00';
        this.sec = '00';
        //Load prevoius recording...
        const audiofile = await fetch(parsedResponse?.data.originalURL);
        const arrayBuffer = await audiofile.arrayBuffer();
        const audioCtx = new AudioContext();
        const decodedData = await audioCtx.decodeAudioData(arrayBuffer);
        const duration = decodedData.duration; // in seconds
        console.log(`🎵 Existing audio duration: ${duration.toFixed(2)}s`);

        // Convert seconds into hr:min:sec
        let totalSeconds = Math.floor(duration);
        const hours = Math.floor(totalSeconds / 3600);
        totalSeconds %= 3600;
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;

        // Assign to component vars (padded with zeros)
        this.hr = hours < 10 ? '0' + hours : hours.toString();
        this.min = minutes < 10 ? '0' + minutes : minutes.toString();
        this.sec = seconds < 10 ? '0' + seconds : seconds.toString();
        this.spinner.hide();
    }
    async removeFileFromDialogClose(action) {
        if (this.ref === "record" && action == "close") {
            this.isStopping = (this.sessionId == null) ? true : false;

            if (this.sessionId != null) {
                await this.backendService.UpdateRecording(this.sessionId).subscribe(
                    async (response: any) => {
                        if (response.success) {
                            this.sessionId = response.data.recording.sessionId;
                        }

                        // Delete chunks from IndexedDB safely
                        const db = await this.dbPromise;
                        const allChunks = (await db.getAll('chunks')) || [];
                        const sessionChunks = allChunks.filter(c => c.sessionId === this.sessionId);

                        if (sessionChunks.length) {
                            const tx = db.transaction('chunks', 'readwrite');
                            const store = tx.objectStore('chunks');
                            for (const chunk of sessionChunks) {
                                await store.delete(chunk.id);
                            }
                            await tx.done;
                            console.log(`✅ Deleted ${sessionChunks.length} chunks for session ${this.sessionId}`);
                        } else {
                            console.log('📭 No chunks found for this session.');
                        }
                        this.isRecording = false;
                        this.sessionId = '';
                        this.convertedRecordingURL = "";
                        this.originalRecordingURL = "";
                        this.IsAudioPlay = false;
                        this.recordingFileName = "";
                        this.file = null;
                        this.originalFile = null;
                        this.RecordingTimer = false;
                        this.IsAudioPlay = false;
                        clearInterval(this.interval);
                        this.fileCount = 0;
                        this.ListOfOriginalFiles = [];
                        ListzipFiles = [];
                        this.ListOfAudioFiles = [];
                        this.DisableStopRecording = false;
                        this.CloseMediaDialogData();
                        this.spinner.hide();
                    },
                    (error) => {
                        console.error('UpdateRecording', error);
                    }
                );
            }
        }
    }
    CloseMediaDialogData() {
        this.mediaDialogData.ListOfAudioFiles = this.ListOfAudioFiles;
        this.mediaDialogData.ListOfOriginalFiles = this.ListOfOriginalFiles;
        this.mediaDialogData.canUpload = this.canUpload;
        this.mediaDialogData.originalFile = this.originalFile;
        this.mediaDialogData.FileType = (this.ref === "media") ? this.FileType : "mp3";
        this.mediaDialogData.ListzipFiles = ListzipFiles;
        this.mediaDialogData.ListOfAudioFiles1 = this.ListOfAudioFiles1;
        this.mediaDialogData.IsMergeAudios = this.IsMergeAudios;
        this.mediaDialogData.ListOfMergeAudioFiles = this.ListOfMergeAudioFiles;
        this.mediaDialogData.MergeAudioFileNameList = this.MergeAudioFileNameList;
        this.mediaDialogData.isRecording = (this.ref === "record") ? true : false;
        this.mediaDialogData.recordingSessionId = this.sessionId;
        this.dialogRef.close(this.mediaDialogData);
    }
    async PlayDetails() {
        if (this.ref === "record") {
            const response: any = await this.backendService.GetPreviousRecording().toPromise();
            var recorddetails = await this.backendService.getJSONResponse(response);
            if (recorddetails.data.recording != null) {
                if (recorddetails.data.recording.isUploaded && recorddetails.data.recording.isConverted) {
                    this.originalRecordingURL = recorddetails.data.originalURL;
                    this.convertedRecordingURL = recorddetails.data.convertedURL;
                    this.IsAudioPlay = true;
                }
                else {
                    this.sendNotification('Your recording is currently being converted. This may take a few moments.', 'error');
                }
            }
        }
    }
    delay(ms: number) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }
}